import React, { useState, useEffect ,useRef } from "react";
import config from "config";
import Spinner from "NOTICEBOARD/CommonResources/SpinnerLoader/Spinner";
import NoticeboardAPICall from "NoticeboardAPICall";
import "NOTICEBOARD/Components/PostNotice/PostNotice.css";
import { Base64 } from 'js-base64';
import { Editor } from '@tinymce/tinymce-react';
import { AttachFile, Close, } from "@mui/icons-material";
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import axios from 'axios';
import SuccessModal from 'NOTICEBOARD/CommonResources/SuccessModal/SuccessModal';
import ButtonLoader from "NOTICEBOARD/CommonResources/ButtonLoader/ButtonLoader";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import moment from "moment";
import ReactHtmlParser from "react-html-parser";
import { toast, ToastContainer } from 'react-toastify';
import FroalaEditor from 'react-froala-wysiwyg';

// Import Froala Editor CSS and JS files

import 'froala-editor/css/froala_editor.pkgd.min.css';
import 'froala-editor/css/froala_style.min.css';
import 'froala-editor/css/themes/dark.min.css';
import 'froala-editor/js/froala_editor.pkgd.min.js';
import 'froala-editor/js/plugins/align.min.js';
import 'froala-editor/js/plugins/code_beautifier.min.js';
import 'froala-editor/js/plugins/code_view.min.js';
import 'froala-editor/js/plugins/colors.min.js';
import 'froala-editor/js/plugins/draggable.min.js';
import 'froala-editor/js/plugins/emoticons.min.js';
import 'froala-editor/js/plugins/font_size.min.js';
import 'froala-editor/js/plugins/fullscreen.min.js';
import 'froala-editor/js/plugins/image.min.js';
import 'froala-editor/js/plugins/link.min.js';
import 'froala-editor/js/plugins/lists.min.js';
import 'froala-editor/js/plugins/paragraph_format.min.js';
import 'froala-editor/js/plugins/paragraph_style.min.js';
import 'froala-editor/js/plugins/quick_insert.min.js';
import 'froala-editor/js/plugins/table.min.js'; // Import table plugin
import 'froala-editor/js/plugins/url.min.js';
import 'froala-editor/js/plugins/word_paste.min.js';

function PostNotice({ 
    updateData, 
    noticeList, 
    setNoticeList, 
    editMode,  
    getMessage, 
    setPostNotice,
    noticeAdded,
    }) {

    const editorRef = useRef(null);
	const editorEditRef = useRef(null);
    
    // apiPath
    let apiPathGetUserAssignedCategoryList = "/api/notice/category.php";
    let apiPathAcademicYearListObject = "/api/admission/streamManagement.php";
    let apiPathGetInstituteStreamsObject = "/api/admission/streamManagement.php";
    let apiPathPostNotice = "/api/notice/notice.php";

    let allowedFileExtensions = ['jpg', 'png', 'jpeg', 'pdf'];

    // VARIABLES TO GET ACADEMIC YEAR LIST
    const [academicYearList, setAcademicYearList] = useState({});
    const [academicYearSortedArr, setAcademicYearSortedArr] = useState([]);


    // VARIABLES TO GET DEPARTMENT LIST
    const [departmentList, setDepartmentList] = useState({});

    // VARIABLES TO GET USER ASSIGNED CATEGORY LIST
    const [offset, setOffset] = useState(0);
    const [limit, setLimit] = useState(10);
    const [activePage, setActivePage] = useState(1);
    const [categoryFetching, setCategoryFetching] = useState(false);
    const [searchCategory, setCategorySearch] = useState('');
    const [searchCategorySeries, setCategorySearchSeries] = useState('');
    const [categoryList, setCategoryList] = useState({});
    const [categoryAccess, setCategoryAccess] = useState({});
    const [instituteDepartment, setInstituteDepartment] = useState({})

    const [selectedInstDept, setSelectedInstDept] = useState(updateData.institute_department_array ? updateData.institute_department_array : []);

    // VARIABLES TO GET CATEGORY DEPARTMENT
    const [categoryDepartmentFetching, setCategoryDepartmentFetching] = useState(false);
    const [categoryAssignedDepartment, setCategoryAssignedDepartment] = useState({});

    // VARIABLES TO ADD / UPDATE NOTICE DETAILS
    const [noticeCategoryId, setNoticeCategoryId] = useState(updateData.categoryId ? updateData.categoryId : "");
    const [last_noticeCategoryId, setlast_noticeCategoryId] = useState(updateData.categoryId ? updateData.categoryId : "");
    const [tempNoticeCategoryId, setTempNoticeCategoryId] = useState(updateData.categoryId ? updateData.categoryId : "");
    const [noticeCategoryName, setNoticeCategoryName] = useState(updateData.categoryName ? updateData.categoryName : "");
    const [tempNoticeCategoryName, setTempNoticeCategoryName] = useState(updateData.categoryName ? updateData.categoryName : "");
    const [categorySelectionWarning, setCategorySelectionWarning] = useState('');
    const [noticeCategoryWarning, setNoticeCategoryWarning] = useState('');
    const [noticeTitle, setNoticeTitle] = useState(updateData.title ? updateData.title : "");
    const [noticeTitleWarning, setNoticeTitleWarning] = useState('');
    const [addNoticeDescription , setAddNoticeDescription] = useState(updateData.description ? updateData.description : "");
    const [noticeDescriptionWarning, setNoticeDescriptionWarning] = useState('');
    const [noticeDateTime, setNoticeDateTime] = useState(updateData.noticeDate ? updateData.noticeDate.split(' ')[0] + 'T' + updateData.noticeDate.split(' ')[1] : "");
    const [noticeDateTimeWarning, setNoticeDateTimeWarning] = useState('');
    const [noticeAttachments, setNoticeAttachment] = useState([]);
    const [addedAttachments, setAddedAttachments] = useState(updateData.attachment ? (updateData.attachment == '' ? [] : updateData.attachment.split(',')) : []);
    const [noticeAttachmentWarning, setNoticeAttachmentWarning] = useState('');
    const [noticeAcademicYearId, setNoticeAcademicYearId] = useState(updateData.academicYearId ? updateData.academicYearId : "");
    const [noticeAcademicYear, setNoticeAcademicYear] = useState(updateData.academicYear ? updateData.academicYear : "");
    const [noticeAcademicYearWarning, setNoticeAcademicYearWarning] = useState('');
    const [selectNoticeDepartment, setSelectNoticeDepartment] = useState(false);
    const [selectNoticeInstDepartment, setSelectNoticeInstDepartment] = useState(false);
    const [noticeDepartment, setNoticeDepartment] = useState(updateData.department ? updateData.department : "");
    const [tempNoticeDepartmentIds, setTempNoticeDepartmentIds] = useState(updateData.department_array ? updateData.department_array : []);
    const [noticeDepartmentIds, setNoticeDepartmentIds] = useState(updateData.department_array ? updateData.department_array : []);
    const [noticeDepartmentWarning, setNoticeDepartmentWarning] = useState('');
    const [noticeInstDepartmentWarning, setNoticeInstDepartmentWarning] = useState('');
    const [departmentSelectionWarning, setDepartmentSelectionWarning] = useState('');
    const [displayOnWebsite, setDisplayOnWebsite] = useState(updateData.display_on_website ? updateData.display_on_website : false);
    const [notifyOnMobile, setNotifyOnMobile] = useState(false);
    const [studentAssigneeObject, setStudentAssigneeObject] = useState({});
    const [teachingAssigneeObject, setTeachingAssigneeObject] = useState({});
    const [nonTeachingAssigneeObject, setNonTeachingAssigneeObject] = useState({});
    const [assigneesDetails, setAssigneeDetails] = useState({
        teaching: {},
        non_teaching: {},
        student: {}
    });
    const [noticeId, setNoticeId] = useState("");
    const [fetchingFaculty, setFetchingFaculty] = useState(false);
    const [selectedTeachingFaculty, setSelectedTeachingFaculty] = useState({});
    const [selectedNonTeachingFaculty, setSelectedNonTeachingFaculty] = useState({});
    const [postingNotice, setPostingNotice] = useState(false);
    const [assignAssignee, setAssignAssignee] = useState(false);
    const [student, setStudent] = useState(false);
    const [teaching, setTeaching] = useState(false);
    const [nonTeaching, setNonTeaching] = useState(false);




    const [removedAttachmentArray, setRemovedAttachmentArray] = useState([]);
    const [noticeUniqueId, setNoticeUniqueId] = useState(updateData.noticeId ? updateData.noticeId : '');
    const [isDefaultBranchOn, setIsDefaultBranchOn] = useState(false);
    const [editNoticeDescription , setEditNoticeDescription] = useState({});


    // VARIABLES TO SELECT CATEGORY
    const [selectCategory, setSelectCategory] = useState(false);
    const [categorySearch, setSearchCategory] = useState('');

    // VARIABLES TO ADD NEW CATEGORY
    const [addCategory, setAddCategory] = useState(false);
    const [categoryTitle, setCategoryTitle] = useState('');
    const [categoryTitleWarning, setCategoryTitleWarning] = useState('');
    const [categoryDescription, setCategoryDescription] = useState('');
    const [categoryDescriptionWarning, setCategoryDescriptionWarning] = useState('');
    const [categoryDepartment, setCategoryDepartment] = useState([]);
    const [categoryDepartmentWarning, setCategoryDepartmentWarning] = useState('');
    const [addingCategory, setAddingCategory] = useState(false);
    const [selectedCategoryId, setSelectedCategoryId] = useState('');
    const [selectedCategoryName, setSelectedCategoryName] = useState('');
    const [viewDepartment, setViewDepartment] = useState(false);


    // VARIABLES TO REQUEST ACCESS
    const [requestAccess, setRequestAccess] = useState(false);
    const [categoryAdmins, setCategoryAdmins] = useState([]);
    const [requestingAccess, setRequestingAccess] = useState(false);

    // STATES FOR TAB
    const [postNoticeActiveTab, setPostNoticeActiveTab] = useState(0);
    const [postNoticeTabArray, setPostNoticeTabArray] = useState([
        {
            tabName: 'Basic Details',
            iconName: '1'
        },
        {
            tabName: 'Assignee',
            iconName: '2'
        }
    ]);

    // STATES FOR TAB
    const [assigneeTab, setAssigneeTab] = useState('STUDENTS');
    const [assigneeTabArray, setAssigneeTabArray] = useState(
        [
            {
                tabName: 'STUDENTS',
                name: ''
            },
            {
                tabName: 'TEACHING',
                name: 'teaching'
            },
            {
                tabName: 'NON-TEACHING',
                name: 'nonteaching'
            }
        ]
    );

    // STATE FOR SUCCESS MODAL
    const [successModalDetails, setSuccessModalDetails] = useState({
        successModal: false,
        successModalType: '',
        successMessage: ''
    });

    const [categorySeries, setCategorySeries] = useState('');
    const [categorySeriesError, setCategorySeriesError] = useState('');	      
    const [froalaKeyAvailable, setFroalaKeyAvailable] = useState(false);	    
    const [froala_auth_key, setFroala_auth_key] = useState('');	    

    // API METHOD TO GET TEMPLATE LIST
    const getfroalaKey = async () => {

        let jsonResponse = await NoticeboardAPICall.makeApiCall(
            "getfroalaKey",
            {},
            "/api/idCard/idcard.php"
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                getfroalaKey();
            }, 1000);
        } else {
            if (jsonResponse.success) {
                  
                setFroala_auth_key(jsonResponse.APIResult.froala_auth_key)
                setFroalaKeyAvailable(true)
            } else {
                setSuccessModalDetails({
                    successModal:true,
                    successModalType:"error",
                    successMessage:"Something went wrong while getting template  list. Please try again later.",
                });
            }
        }
    };

    // METHOD CALLED TO GET ACADEMIC YEAR LIST
    useEffect(() => {
        getfroalaKey();
    }, []);

    // METHOD CALLED TO GET ACADEMIC YEAR LIST
    useEffect(() => {
        apiCallToGetAcademicYearList();
    }, []);

    useEffect(() => {
        apiCallToGetDepartmentList();
        apiCallToGetInstituteDepartment()
    }, []);

    // METHOD CALLED TO GET USER ASSIGNED CATEGORY LIST
    useEffect(() => {
        apiCallToGetUserAssignedCategoryList();
    }, []);

    // HOOKS FOR USER ASSIGNED CATEGORY STREAM LIST API CALL
    useEffect(() => {
        if(noticeCategoryId != '') {
            apiCallToGetCategoryStreamList();
        }
    }, [noticeCategoryId]);

    // HOOKS FOR GETTING GROUPS AND STUDENT LIST AFTER ACADEMIC YEAR CHANGE
    useEffect(() => {
        if(noticeAcademicYearId != ''){
            if(assigneeTab == 'STUDENTS') {
                if(Object.keys(studentAssigneeObject).length > 0) {
                    Object.keys(studentAssigneeObject).map(departmentId => {
                        apiCallToGetGroupDetails(departmentId);
                    });
                }
            }else if(assigneeTab == 'TEACHING') {
                if(Object.keys(teachingAssigneeObject).length > 0) {
                    Object.keys(teachingAssigneeObject).map(departmentId => {
                        if(teachingAssigneeObject[departmentId].facultyList.length == 0) {
                            apiCallToGetFacultyList(teachingAssigneeObject[departmentId].searchKey, departmentId, 'teaching');
                        }
                    });
                }
            }else if(assigneeTab == 'NON-TEACHING'){
                if(Object.keys(nonTeachingAssigneeObject).length > 0) {
                    Object.keys(nonTeachingAssigneeObject).map(departmentId => {
                        if(nonTeachingAssigneeObject[departmentId].facultyList.length == 0) {
                            apiCallToGetFacultyList(nonTeachingAssigneeObject[departmentId].searchKey, departmentId, 'nonteaching');
                        }
                    });
                }
            }
        }
    }, [noticeAcademicYearId]);

    const apiCallToGetInstituteDepartment = async () => {
        setInstituteDepartment({})
        let requestData = {
            institute_id: config.institute_id,
        };


        let jsonResponse = await NoticeboardAPICall.makeApiCall(
            'getDepartmentsListWithoutPagination',
            requestData,
            "/api/instructor/instituteDepartments.php"
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                apiCallToGetInstituteDepartment()
            }, 1000);
        } else {
            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult.data
                setInstituteDepartment(apiResult)
               
            } else {
                toast.error("Something went wrong while getting institute department. Please contact.")
            }
        }
    }
    // API CALL METHOD TO GET ACADEMIC YEAR LIST
    const apiCallToGetAcademicYearList = async () => {
        let formData = {
            iid: config.institute_id,
        };

        let jsonResponse = await NoticeboardAPICall.makeApiCall(
            "GetAcademicYearListObject",
            formData,
            apiPathAcademicYearListObject
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                apiCallToGetAcademicYearList();
            }, 1000);
        } else {
            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult.data;
                setAcademicYearList(apiResult);
                setAcademicYearSortedArr(jsonResponse.APIResult.sortedIdArray)
            } else {
                setSuccessModalDetails({
                    successModal:true,
                    successModalType:"error",
                    successMessage:"Something went wrong while getting academic year list. Please try again later."
                });
            }
        }
    };

    // API CALL METHOD TO GET DEPARTMENT LIST
    const apiCallToGetDepartmentList = async () => {
        let formData = {
            iid: config.institute_id,
            sidArray: [],
        };

        let jsonResponse = await NoticeboardAPICall.makeApiCall(
            "GetInstituteStreamsObject",
            formData,
            apiPathGetInstituteStreamsObject
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                apiCallToGetDepartmentList();
            }, 1000);
        } else {
            if (jsonResponse.success) {
                let apiResult = await jsonResponse.APIResult.data;
                setDepartmentList(apiResult);
            } else {
                setSuccessModalDetails({
                    successModal: true,
                    successModalType: "error",
                    successMessage: "Something went wrong while getting department list. Please try again later."
                });
            }
        }
    };
    
    // API CALL TO GET USER ASSIGNED CATEGORY LIST
    const apiCallToGetUserAssignedCategoryList = async () => {
        setCategoryFetching(true);

        let formData = {
            institute_id: config.institute_id,
            employee_id: config.faculty_id,
        };

        let jsonResponse = await NoticeboardAPICall.makeApiCall(
            "getUserAssignedCategoryList",
            formData,
            apiPathGetUserAssignedCategoryList
        );
        if (jsonResponse.expired) {
            setTimeout(() => {
                apiCallToGetUserAssignedCategoryList();
            }, 1000);
        } else {
            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult.data;
                setCategoryAccess(jsonResponse.APIResult);
                setCategoryList(apiResult);
                setCategoryFetching(false);
            } else {
                setCategoryFetching(true);
                setSuccessModalDetails({
                    successModal:true,
                    successModalType:"error",
                    successMessage:"Something went wrong while getting user assigned category list. Please try again later."
                });
            }
        }
    };

    // method for get User Assigned Category StreamList api call
    const apiCallToGetCategoryStreamList = async () => {
        setCategoryDepartmentFetching(false);
        let formData = {
            institute_id: config.institute_id,
            employee_id: config.faculty_id,
            category_id: noticeCategoryId,
        };
        let jsonResponse = await NoticeboardAPICall.makeApiCall(
            "getUserAssignedCategoryStreamList",
            formData,
            apiPathGetUserAssignedCategoryList
        );
        if (jsonResponse.expired) {
            setTimeout(() => {
                apiCallToGetCategoryStreamList();
            }, 1000);
        } else {
            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult.data;
                if(Object.keys(apiResult).length > 0) {
                    Object.keys(apiResult).map(streamId => {
                        apiResult[streamId]['streamId'] = streamId;
                    });
                }
                setCategoryDepartmentFetching(false);
                setCategoryAssignedDepartment(apiResult);
            } else {
                setCategoryDepartmentFetching(false);
                setSuccessModalDetails({
                    successModal:true,
                    successModalType:"error",
                    successMessage:"Something went wrong while getting category stream list. Please try again later."
                });
            }
        }
    }

    // const showModalSelectCustomDiv = () => {
    //     return <div>
    //         <div className="modal fade show" id="modalContainer">
    //             <div className="modal-dialog modal-dialog-centered">
    //                 <div className="modal-content">
    //                     <div
    //                         className="modal-header d-flex text-center p-2"
    //                         style={ { backgroundColor: "#0465ac" } }
    //                     >
    //                         <div className=" flex-grow-1">
    //                             <p className="modal-title text-white">Students of First Semester of Computer Enginnering</p>
    //                         </div>
    //                         <div className="">
    //                             <Close
    //                                 style={ { color: "white", cursor: "pointer" } }
    //                                 onClick={ () => {
    //                                     setShowModalSelectCustom(false);
    //                                 } }
    //                             />
    //                         </div>
    //                     </div>
    //                     <div className="modal-body scrollController">
    //                         <div className='table-responsive'>
    //                             <table className="table table-sm table-fixed table-bordered">
    //                                 <thead >
    //                                     <tr className='secondaryColor' >
    //                                         <th className='tableHeading' scope="col">
    //                                             <input
    //                                                 type='checkbox'
    //                                             />
    //                                         </th>
    //                                         <th className='tableHeading' scope="col">Sr. No.</th>
    //                                         <th className='tableHeading' scope="col">Roll No</th>
    //                                         <th className='tableHeading' scope="col">Name</th>
    //                                     </tr>
    //                                 </thead>
    //                                 <tbody>
    //                                     { getStudentAssignedToGroup && Object.keys(getStudentAssignedToGroup).map((studentKey, studentIndex) => {
    //                                         let student = getStudentAssignedToGroup[studentKey];
    //                                         return <tr className='smallFont secondaryColor'>
    //                                             <td className='tableHeading' scope="col">
    //                                                 <input
    //                                                     type='checkbox'
    //                                                 />
    //                                             </td>
    //                                             <td className='tableData'>{ studentIndex }</td>
    //                                             <td className='tableData'>{ student.RollNo }</td>
    //                                             <td className='tableData'>{ student.student_first_name } { student.student_last_name }</td>
    //                                         </tr>
    //                                     }) }
    //                                 </tbody>
    //                             </table>
    //                         </div>
    //                     </div>
    //                     <div className="col-md-12 d-flex justify-content-between align-items-center">
    //                         <div></div>
    //                         <div>
    //                             <button
    //                                 type="button"
    //                                 className="btn py-1 modalSelectButton"
    //                                 onClick={ () => selectCustomStudents() }
    //                             >
    //                                 Selects
    //                             </button>
    //                         </div>
    //                     </div>
    //                 </div>
    //             </div>
    //         </div>
    //     </div>
    // }

    // METHOD TO CHANGE FORM PAGE
    const changeFormPage = (index) => {
        if(index == 1) {
            validateBasicDetails();
        }
    }

    // METHOD TO SELECT CATEGORY
    const selectNoticeCategory = () => {
        setSelectCategory(true);
      
        if (Object.keys(categoryList).length > 0) {
          setCategoryFetching(false);
        } else if (categoryAccess?.access_provided?.manage_notice_category) {
          const manageNoticeCategory = categoryAccess.access_provided.manage_notice_category;
      
          if (manageNoticeCategory.isAccessGranted === 'true') {
            setAddCategory(true);
          } else if (manageNoticeCategory.isAccessGranted === 'false') {
            const accessGrantedTo = manageNoticeCategory.accessGrantedTo || [];
            const adminSet = new Set();
      
            if (accessGrantedTo.length > 0) {
              accessGrantedTo.forEach(access => {
                adminSet.add(access.name);
              });
            }
      
            setCategoryAdmins(Array.from(adminSet));
            setRequestAccess(true);
          }
        }
      };
      
    // METHOD TO RETURN SELECT CATEGORY MODAL
    const returnSelectCategory = () => {
        let matchingCount = 0;
        return(
            <div>
                <div className="modal fade show" id="modalContainer">
                    <div className="modal-dialog" style={{ maxWidth: '50%' }}>
                        <div className="modal-content" style={{ height: 'calc(100vh - 50px)' }}>
                            <div className="modal-header d-flex text-center p-2" style={{ backgroundColor: "#0465ac" }}>
                                <div className=" flex-grow-1">
                                    <p className="modal-title text-white">Select Category</p>
                                </div>
                                <div className="">
                                    <Close
                                        style={ { color: "white", cursor: "pointer" } }
                                        onClick={ () => cancelCategorySelection()}
                                    />
                                </div>
                            </div>
                            <div className="modal-body scrollController" style={{ maxHeight: '100%' }}>
                                {
                                    Object.keys(categoryList).every(id => categoryList[id].status == 'Inactive') ? 
                                    'No categories assigned to you.' :
                                    <>
                                        <div className='col-12 smallFont text-center secondaryColor' style={{ marginBottom: 10, padding: 0 }}>
                                            Categories assigned to you.
                                        </div>
                                        <div className="col-md-12" style={{ padding: 0 }}>
                                            <input
                                                className="form-control searchCategoryInput"
                                                type="text"
                                                placeholder="Search category..."
                                                value={searchCategory}
                                                onChange={ (e) => setCategorySearch(e.target.value)}
                                            />
                                        </div>
                                    </>
                                }
                                {
                                    categoryFetching ?
                                        <Spinner />
                                    :
                                        (categoryList && Object.keys(categoryList).length > 0) &&
                                            Object.keys(categoryList).map((categoryId) => {
                                                
                                                if(categoryList[categoryId].status == 'Inactive') return

                                                if(searchCategory.length > 0){
                                                    if(categoryList[categoryId].categoryName.toLowerCase().includes(searchCategory.toLowerCase())) 
                                                    {
                                                        matchingCount = matchingCount + 1;
                                                        return (
                                                            <>
                                                                <div className="row py-1">
                                                                    <div className="col-12 form-check" style={{ textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'nowrap' }} title={categoryList[categoryId].categoryName}>
                                                                        <input
                                                                            className="form-check-input"
                                                                            name="flexRadioDefault"
                                                                            type="radio"
                                                                            checked={tempNoticeCategoryId == categoryId}
                                                                            onChange={() => selectNoticeCategoryId(categoryId,categoryList[categoryId].categorySeries)}
                                                                            id="flexRadioDefault1"
                                                                        />
                                                                        <span className="smallFont">
                                                                            {categoryList[categoryId].categoryName}
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                            </>
                                                        );
                                                    }
                                                }else {
                                                    return (
                                                        <>
                                                            <div className="row py-1">
                                                                <div className="col-12 form-check" style={{ textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'nowrap' }} title={categoryList[categoryId].categoryName}>
                                                                    <input
                                                                        className="form-check-input"
                                                                        name="flexRadioDefault"
                                                                        type="radio"
                                                                        checked={tempNoticeCategoryId == categoryId}
                                                                        onChange={() => selectNoticeCategoryId(categoryId,categoryList[categoryId].categorySeries)}
                                                                        id="flexRadioDefault1"
                                                                    />
                                                                    <span className="smallFont">
                                                                        {categoryList[categoryId].categoryName}
                                                                    </span>
                                                                </div>
                                                            </div>
                                                        </>
                                                    );
                                                }
                                            })
                                }
                                {
                                    (searchCategory.length > 0 && matchingCount == 0) &&
                                        <p className="secondaryColor smallFont" style={{ marginTop: 10 }}>No category found as per search.</p>
                                }
                                <p style={{ fontSize: 12 }} className="text-danger">{categorySelectionWarning}</p>
                            </div>
                            <div className="modal-footer mx-2">
                                {
                                    !Object.keys(categoryList).every(id => categoryList[id].status == 'Inactive') &&
                                    <button type="button" className="btn btn-primary py-1" onClick={() => confirmCategorySelection()}>
                                        Select
                                    </button>
                                }
                                <button type="button" className="btn btn-outline-primary py-1" onClick={() => cancelCategorySelection()}>
                                    Cancel
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    // METHOD TO SELECT NOTICE CATEGORY ID
    const selectNoticeCategoryId = (categoryId,series) => 
    {
        setCategorySearchSeries(series)
        setTempNoticeCategoryId(categoryId);
        setTempNoticeCategoryName(categoryList[categoryId].categoryName);
        setCategorySelectionWarning('');
    }

    // METHOD TO CONFIRM CATEGORY SELECTION
    const confirmCategorySelection = () => {
        if(tempNoticeCategoryId.length < 1) {
            setCategorySelectionWarning('Please select category to proceed.');
        }else {
            setNoticeCategoryId(tempNoticeCategoryId);
            setNoticeCategoryName(tempNoticeCategoryName);
            setSelectCategory(false);
            setCategorySelectionWarning('');
            setNoticeCategoryWarning('');
        }
    }

    // METHOD TO CANCEL CATEGORY SELECTION
    const cancelCategorySelection = () => {
        setSelectCategory(false);
        setTempNoticeCategoryId(noticeCategoryId);
        setTempNoticeCategoryName(noticeCategoryName);
        setCategorySelectionWarning('');
        setCategorySearchSeries('');
        setlast_noticeCategoryId("");

    }

    	// METHOD TO GET CATEGORY NAME
	const getCategorySeries = (e) => {
		if (e.target.value.trim() == '') 
		{
			setCategorySeries(e.target.value);
			setCategorySeriesError("Category series cannot be empty.");
		} 
		else {
			setCategorySeries(e.target.value);
			setCategorySeriesError("");
		}
	}

    // METHOD TO RETURN ADD CATEGORY MODAL
    const returnAddCategory = () => {
        return <div>
            <div className="modal fade show" id="modalContainer">
                <div className="modal-dialog modal-dialog-centered" style={{ maxWidth: '50%' }}>
                    <div className="modal-content" style={{ height: 'calc(100vh - 80px)' }}>
                        <div className="modal-header d-flex text-center p-2" style={{ backgroundColor: "#0465ac" }}>
                            <div className=" flex-grow-1">
                                <p className="addCategoryTitle">Department Wise Category Access</p>
                            </div>
                            <div className="">
                                <Close
                                    style={{ color: "white", cursor: "pointer" }}
                                    onClick={() => closeAddCategory()}
                                />
                            </div>
                        </div>
                        <div className="modal-body" style={{ maxHeight: '100%' }}>
                            <div className="col-md-12 p-2">
                                <label className="modalTitle">
                                    Category Name<span className="text-danger ml-1">*</span>
                                </label>
                                <input
                                    className="form-control postNoticeInput"
                                    type="text"
                                    placeholder="Enter category name"
                                    value={ categoryTitle }
                                    onChange={ (e) => getCategoryTitle(e) }
                                    maxLength='100'
                                />
                                <div className='py-0 d-flex justify-content-end smallFont secondaryColor'>Maximum 100 characters are allowed.</div>
                                <p className='text-danger' style={ { fontSize: 12 } } >{ categoryTitleWarning }</p>
                            </div>
                            <div>
                                <div className='categorySeries'>
                                    <label style={{ fontWeight: "bold", fontSize: 14 }}>Category Series <span style={{ color: 'red' }}>*</span></label>
                                    <input
                                        type="text"
                                        className='form-control addCategoryInput '
                                        placeholder='Enter Category Series'
                                        value={categorySeries}
                                        onChange={(e) => getCategorySeries(e)}
                                        style={{ fontSize: 14 }}
                                        maxLength='100'
                                    />
                                    <div className='infoMessage'>Maximum 100 characters are allowed.</div>
                                    <p className='text-danger' style={{ fontSize: 12 }}>{categorySeriesError}</p>
                                </div>
                                <div className='cardFacultyTitle' style={{ backgroundColor: "#FFF8DD" }} >
                                    <p>
                                        Note - Please note that once a series number is assigned to a Category, a Notice ID will be automatically generated.
                                    </p>
                                    <p> Example : <b>Category Series - Exam and Notice ID - Exam - 01</b> </p>
                                </div>

                            </div>
                            <div className="col-md-12 p-2">
                                <label className="modalTitle">
                                    Category Description<span className="text-danger ml-1">*</span>
                                </label>
                                <input
                                    className="form-control postNoticeInput"
                                    type="text"
                                    placeholder="Enter category description"
                                    value={ categoryDescription }
                                    onChange={ (e) => getCategoryDescription(e) }
                                    maxLength='500'
                                />
                                <div className='py-0 d-flex justify-content-end smallFont secondaryColor'>Maximum 500 characters are allowed.</div>
                                <p className='text-danger' style={ { fontSize: 12 } } >{ categoryDescriptionWarning }</p>
                            </div>
                            <div className="col-md-12 p-2">
                                <label className="modalTitle">
                                    Department<span className="text-danger ml-1">*</span>
                                </label>
                                <br />
                                <input
                                    className="form-control postNoticeInput pointer"
                                    type="text"
                                    placeholder="Select department"
                                    onClick={ (e) => setViewDepartment(!viewDepartment) }
                                    maxLength='100'
                                    readOnly
                                />
                                {
                                    viewDepartment && 
                                        <div id="" className="scrollController selectDepartmentForFeatureDiv">
                                        {
                                            Object.keys(departmentList).length > 0 &&
                                                Object.keys(departmentList).map(streamKey => {
                                                    return (

                                                        <div className='selectDepartmentForFeatureDiv_innerDiv'>
                                                            <input
                                                                type='checkbox'
                                                                style={ { marginRight: 10 }}
                                                                checked={categoryDepartment.includes(streamKey)}
                                                                onChange={ (e) => selectCategoryDepartment(e, streamKey) }
                                                            />
                                                            <span className='smallFont2'>{ departmentList[streamKey].stream_name }</span>
                                                        </div>
                                                    );
                                                })
                                        }
                                    </div> 
                                }
                                <p style={{ fontSize: 12 }} className="text-danger">{categoryDepartmentWarning}</p>
                                {
                                    (categoryDepartment && Object.keys(categoryDepartment).length > 0) &&
                                        categoryDepartment.map(departmentKey => {
                                            return (
                                                <div className=''>
                                                    <span className='smallFont2'>{ departmentList[departmentKey].stream_name }</span>
                                                    <Close
                                                        className='smallFont pointer text-danger'
                                                        onClick={ () => removeCategoryDepartment(departmentKey) }
                                                    />
                                                </div>
                                            );
                                        })
                                }
                            </div>
                        </div>
                        <div className="modal-footer">
                            {
                                addingCategory &&
                                    <ButtonLoader />
                            }
                            <button className="btn btn-primary" onClick={() => validateAddCategory()} disabled={addingCategory}>Add</button>
                            <button className="btn btn-outline-primary" onClick={() => closeAddCategory()}>Cancel</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    }

    // METHOD TO GET CATEGORY NAME
    const getCategoryTitle = (e) => {
        setCategoryTitle(e.target.value);

        if(e.target.value.trim().length < 1) {
            setCategoryTitleWarning('Category title cannot be empty.');
        }else {
            setCategoryTitleWarning('');
        }
    }

    // METHOD TO GET CATEGORY DESCRIPTION
    const getCategoryDescription = (e) => {
        setCategoryDescription(e.target.value);

        if(e.target.value.trim().length < 1) {
            setCategoryDescriptionWarning('Category description cannot be empty.');
        }else {
            setCategoryDescriptionWarning('');
        }
    }

    // METHOD TO SELECT DEPARTMENT FOR ADDING CATEGORY
    const selectCategoryDepartment = (e, streamKey) => {
        let categoryDepartments = categoryDepartment;
        if(categoryDepartments.includes(streamKey)) {
            categoryDepartments = categoryDepartments.filter(id => id != streamKey);
        }else {
            categoryDepartments.push(streamKey);
        }
        setCategoryDepartment([ ...categoryDepartments ]);

        if(categoryDepartments.length < 1) {
            setCategoryDepartmentWarning('Please select at least one department.');
        }else {
            setCategoryDepartmentWarning('');
        }
    }

    // METHOD TO REMOVE CATEGORY DEPARTMENT
    const removeCategoryDepartment = (streamKey) => {
        let categoryDepartments = categoryDepartment.filter(id => id != streamKey);
        setCategoryDepartment([ ...categoryDepartments ]);
    }

    // METHOD TO VALIDATE ADD CATEGORY
    const validateAddCategory = () => {
        let validData = true;

        if(categoryTitle.trim().length < 1) {
            setCategoryTitleWarning('Category title cannot be empty.');
            validData = false;
        }

        if (categorySeries.trim() == "") 
        {
            validData = false
            setCategorySeriesError('Category series cannot be empty.');
        }

        if(categoryDescription.trim().length < 1) {
            setCategoryDescriptionWarning('Category description cannot be empty.');
            validData = false;
        }

        if(categoryDepartment.length < 1) {
            setCategoryDepartmentWarning('Please select at least one department.');
            validData = false;
        }

        if(validData) {
            apiCallToAddCategory();
        }
    }

    // API CALL METHOD TO ADD CATEGORY
    const apiCallToAddCategory = async () => {
        setAddingCategory(true);

        let requestData = {
            "iid": config.institute_id,
            "title": categoryTitle,
            "description": categoryDescription,
            "status": 'Active',
            "series" : categorySeries,
            "addedby": config.faculty_id,
            "sidAccessArray": categoryDepartment,
            "academicYear": ''
        };

        let jsonResponse = await NoticeboardAPICall.makeApiCall(
            "AddNoticeBoardCategory",
            requestData,
            '/api/notice/category.php'
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                apiCallToAddCategory();
            }, 1000);
        }else {
            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult;
                let categoryListObject = categoryList;
                if(apiResult.status == 'success') {
                    if(categoryListObject[apiResult.UID] == undefined) {
                        categoryListObject[apiResult.UID] = {};
                    }

                    categoryListObject[apiResult.UID].categoryName = categoryTitle;

                    setCategoryList({ ...categoryListObject });
                    setTempNoticeCategoryId(apiResult.UID );
                    setNoticeCategoryId(apiResult.UID);
                    setNoticeCategoryWarning('');
                    setTempNoticeCategoryName(categoryTitle);
                    setNoticeCategoryName(categoryTitle);
                    setCategorySearchSeries(categorySeries);
                    setSuccessModalDetails({
                        successModal: true,
                        successModalType: 'success',
                        successMessage: apiResult.message + '.'
                    });
                    setAddingCategory(false);
                    closeAddCategory();
                }else {
                    setSuccessModalDetails({
                        successModal: true,
                        successModalType: 'warning',
                        successMessage: apiResult.message
                    });
                    setAddingCategory(false);
                    closeAddCategory();
                }
            } else {
                setSuccessModalDetails({
                    successModal: true,
                    successModalType: 'error',
                    successMessage: 'Something went wrong while adding category. Please try again later.'
                });
                setAddingCategory(false);
                closeAddCategory();
            }
        }
    }

    // METHOD TO CLOSE ADD CATEGORY
    const closeAddCategory = () => {
        setAddCategory(false);
        setCategoryTitle('');
        setCategoryTitleWarning('');
        setCategoryDescription('');
        setCategoryDescriptionWarning('');
        setCategoryDepartment([]);
        setCategoryDepartmentWarning('');
        setCategorySeriesError("");
        setCategorySeries("");

    }

    // METHOD TO RETURN REQUEST ACCESS
    const returnRequestAccess = () => {
        return(
            <div>
                <div className="modal fade show" id="modalContainer">
                    <div className="modal-dialog modal-dialog-centered">
                        <div className="modal-content">
                            <div className="modal-header d-flex text-center p-2" style={{ backgroundColor: "#0465ac" }}>
                                <div className=" flex-grow-1">
                                    <p className="addCategoryTitle">Request Access</p>
                                </div>
                                <div className="">
                                    <Close style={{ color: "white", cursor: "pointer" }} onClick={() => setRequestAccess(false)} />
                                </div>
                            </div>
                            <div className="modal-body">
                                <p style={{ fontSize: 14 }}><span style={{ fontWeight: 'bold' }}>Category Management</span> access is granted to {categoryAdmins.join(', ')}. Please click on 'Request Access' to get <span style={{ fontWeight: 'bold' }}>Category management</span> access.</p>
                                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', marginTop: 20 }}>
                                    {
                                        requestingAccess &&
                                            <ButtonLoader />
                                    }
                                    <button type="button" className="btn" style={{ backgroundColor: "#0465AC", color: "white" }} onClick={() => apiCallToRequestAccess()} disabled={requestingAccess}>Request Access</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    // API CALL METHOD TO REQUEST ACCESS DETAILS
    const apiCallToRequestAccess = async () => {
        setRequestingAccess(true);

        let requestData = {
            "user_id": config.faculty_id,
            "institute_id": config.institute_id,
            "moduleName": 'Notice Board',
            "module_ID": 42,
            "request_string": 'manage_notice_category',
            "request_for": 'Category Management',
            "sid": ''
        };

        let jsonResponse = await NoticeboardAPICall.makeApiCall(
            "sendAccessRequestMail",
            requestData,
            '/api/accessRequest/accessRequest.php'
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                apiCallToRequestAccess();
            }, 1000);
        }else {
            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult;
                if(apiResult.status == 'success') {
                    setSuccessModalDetails({
                        successModal: true,
                        successModalType: 'success',
                        successMessage: apiResult.message
                    });
                    setRequestAccess(false);
                    setRequestingAccess(false);
                }else {
                    setSuccessModalDetails({
                        successModal: true,
                        successModalType: 'warning',
                        successMessage: apiResult.message
                    });
                    setRequestAccess(false);
                    setRequestingAccess(false);
                }
            } else {
                setSuccessModalDetails({
                    successModal: true,
                    successModalType: 'error',
                    successMessage: 'Something went wrong while requesting access. Please try again later.'
                });
                setRequestAccess(false);
                setRequestingAccess(false);
            }
        }
    }

    // METHOD TO GET NOTICE TITLE
    const getNoticeTitle = (e) => {
        setNoticeTitle(e.target.value);

        if(e.target.value.trim().length < 1) {
            setNoticeTitleWarning('Title cannot be empty.');
        }else {
            setNoticeTitleWarning('');
        }
    }


    // METHOD TO GET NOTICE DATE & TIME
    const getNoticeDateTime = (e) => {
        setNoticeDateTime(e.target.value);

        if(e.target.value.length < 1) {
            setNoticeDateTimeWarning('Please select date & time.');
        }else {
            setNoticeDateTimeWarning('');
        }
    }

    // METHOD TO REMOVE ADDED ATTACHMENTS
    const removeAddedAttachment = (attachment) => {
        let addedAttachment = addedAttachments;
        let removedAttachments = removedAttachmentArray;

        addedAttachment = addedAttachment.filter(file => file != attachment);

        removedAttachments.push(attachment);

        setAddedAttachments([ ...addedAttachment ]);
        setRemovedAttachmentArray([ ...removedAttachments ]);
    }

    // METHOD TO CLICK ON ATTACHMENT SELECTION
    const getAttachmentClick = () => {
        document.getElementById('attachment-files').click();
    }

    // METHOD TO GET ATTACHMENT FILES
    const getAttachmentFiles = (e) => {
        let noticeFiles = noticeAttachments;
        let files = Array.from(e.target.files);

        files.map((file, fileIndex) => {
            noticeFiles.map(noticeFile => {
                if(file.name == noticeFile.name) {
                    file.splice(fileIndex, 1);
                }
            });
        });

        noticeFiles = noticeFiles.concat(files);
        setNoticeAttachment([ ...noticeFiles ]);
        setNoticeAttachmentWarning('');
        let sizeCount = 0;
        let extensionCount = 0;

        files.map(file => {
            if((file.size / 1048576.0) > 5) {
                sizeCount = sizeCount + 1;
            }else if(!allowedFileExtensions.includes(file.name.substring(file.name.lastIndexOf('.') + 1))) {
                extensionCount = extensionCount + 1;
            }
        });

        if(sizeCount > 0) {
            setNoticeAttachmentWarning(`${sizeCount} out of ${files.length} file(s) selected with size more than 5MB.`);
        }else if(extensionCount > 0) {
            setNoticeAttachmentWarning(`${extensionCount} out of ${files.length} file(s) are not having extensions .jpeg, .jpg, .png, .pdf.`);
        }else {
            setNoticeAttachmentWarning('');
        }
    }

    // METHOD TO REMOVE ATTACHMENT
    const removeSelectedAttachment = (attachmentIndex) => {
        let attachments = noticeAttachments;

        attachments.splice(attachmentIndex, 1);

        if(attachments.length < 6) {
            setNoticeAttachmentWarning('');
        }

        setNoticeAttachment([ ...attachments ]);
    }

    // METHOD TO SELECT NOTICE ACADEMIC YEAR
    const selectNoticeAcademicYear = (e) => {
        setNoticeAcademicYearId(e.target.value);

        if(e.target.value.length < 1) {
            setNoticeAcademicYearWarning('Please select academic year.');
            setNoticeAcademicYear('');
        }else {
            setNoticeAcademicYearWarning('');
            setNoticeAcademicYear(e.target.selectedOptions[0].text);
        }
    }

    // METHOD TO RETURN SELECT NOTICE DEPARTMENT
    const returnSelectNoticeDepartment = () => {
        return(
            <div>
                <div className="modal fade show" id="modalContainer">
                    <div className="modal-dialog modal-dialog-centered" style={{ maxHeight: 'fit-content', maxWidth: '50%' }}>
                        <div className="modal-content" style={{ height: 'calc(100vh - 50px)' }}>
                            <div className="modal-header d-flex text-center p-2" style={{ backgroundColor: "#0465ac" }}>
                                <div className=" flex-grow-1">
                                    <p className="modal-title text-white">Select Department</p>
                                </div>
                                <div className="">
                                    <Close style={{ color: "white", cursor: "pointer" }} onClick={() => cancelDepartmentSelection()}/>
                                </div>
                            </div>
                            <div className="modal-body scrollController" style={{ maxHeight: '100%' }}>
                                <div className='smallFont secondaryColor'>Only those departments are visible here for which you can post notice for the notice category assigned to you.</div>
                                {
                                    (noticeCategoryId != '' && Object.keys(categoryAssignedDepartment).length > 0) &&
                                        <div className="selectAllDepartments" style={{ marginTop: 10 }}>
                                            {/* <input
                                                type='checkbox'
                                                checked={Object.keys(categoryAssignedDepartment).length > 0 && (Object.keys(categoryAssignedDepartment).length == tempNoticeDepartmentIds.length)}
                                                style={{ marginRight: 5 }}
                                                onChange={(e) => selectAllDepartments(e)}
                                            />
                                            <span style={{ fontSize: 14 }}>Select All</span> */}
                                        </div>
                                }
                                {
                                    noticeCategoryId != '' ?
                                        Object.keys(categoryAssignedDepartment).length > 0 ?
                                            Object.values(categoryAssignedDepartment).map(department => {
                                                return(
                                                    <div className="departmentSelection">
                                                        <input
                                                            type='checkbox'
                                                            checked={tempNoticeDepartmentIds.includes(department.streamId.toString())}
                                                            style={{ marginRight: 5 }}
                                                            onChange={() => selectSingleDepartment(department.streamId.toString())}
                                                        />
                                                        <span style={{ fontSize: 14 }}>{department.streamName}</span>
                                                    </div>
                                                );
                                            })
                                        :
                                            <p style={{ fontSize: 14, marginTop: 10 }} className="secondaryColor">No department assigned to the selected category.</p>
                                    :
                                        <p style={{ fontSize: 14, marginTop: 10 }}>Please select notice category to get department list.</p>
                                }
                                <p style={{ fontSize: 12 }} className="text-danger">{departmentSelectionWarning}</p>
                            </div>
                            <div className="modal-footer">
                                {
                                    Object.keys(categoryAssignedDepartment).length > 0 &&
                                        <>
                                            <button className="btn btn-primary" onClick={() => confirmDepartmentSelection()}>
                                                Select
                                            </button>
                                            <button className="btn btn-outline-primary" onClick={() => cancelDepartmentSelection()}>
                                                Cancel
                                            </button>
                                        </>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
    const returnSelectNoticeInstDepartment = () => {
        return(
            <div>
                <div className="modal fade show" id="modalContainer">
                    <div className="modal-dialog modal-dialog-centered" style={{ maxHeight: 'fit-content', maxWidth: '50%' }}>
                        <div className="modal-content" style={{ height: 'calc(100vh - 50px)' }}>
                            <div className="modal-header d-flex text-center p-2" style={{ backgroundColor: "#0465ac" }}>
                                <div className=" flex-grow-1">
                                    <p className="modal-title text-white">Select Institute Department</p>
                                </div>
                                <div className="">
                                    <Close onClick ={()=>cancelInstDepartmentSelection()} style={{ color: "white", cursor: "pointer" }}/>
                                </div>
                            </div>
                            <div className="modal-body scrollController" style={{ maxHeight: '100%' }}>
                                {/* <div className='smallFont secondaryColor'>Only those departments are visible here for which you can post notice for the notice category assigned to you.</div> */}
                             
                                {
                                        Object.keys(instituteDepartment).length > 0 ?
                                            Object.values(instituteDepartment).map(department => {
                                                return(
                                                    <div className="departmentSelection">
                                                        <input
                                                            type='checkbox'
                                                            checked={selectedInstDept.includes(department.Id.toString())}
                                                            style={{ marginRight: 5 }}
                                                            onChange={() => handleSelectInstDept(department.Id.toString())}
                                                        />
                                                        <span style={{ fontSize: 14 }}>{department.name}</span>
                                                    </div>
                                                );
                                            })
                                        :
                                            <p style={{ fontSize: 14, marginTop: 10 }} className="secondaryColor">Institute departments are not available</p>
                                    
                                }
                                <p style={{ fontSize: 12 }} className="text-danger">{noticeInstDepartmentWarning}</p>
                            </div>
                            <div className="modal-footer">
                                {
                                    Object.keys(instituteDepartment).length > 0 &&
                                        <>
                                            <button className="btn btn-primary" onClick={() => confirmInstDepartmentSelection()}>
                                                Select
                                            </button>
                                            <button className="btn btn-outline-primary" onClick={() => cancelInstDepartmentSelection()}>
                                                Cancel
                                            </button>
                                        </>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    // METHOD TO SELECT ALL DEPARTMENTS
    const selectAllDepartments = (e) => {
        let departmentIdSet = new Set();

        if(e.target.checked) {
            Object.keys(categoryAssignedDepartment).map(streamId => {
                departmentIdSet.add(streamId);
            });
        }else {
            Object.keys(categoryAssignedDepartment).map(streamId => {
                departmentIdSet.delete(streamId);
            });
        }

        setTempNoticeDepartmentIds(Array.from(departmentIdSet));
    }

    // METHOD TO SELECT SINGLE DEPARTMENT
    const selectSingleDepartment = (streamId) => {
        let departmentIds = tempNoticeDepartmentIds;
     
        if(departmentIds.includes(streamId)) {
            departmentIds = departmentIds.filter(id => id != streamId);
        }
        else {
            departmentIds.push(streamId)
        }
        setTempNoticeDepartmentIds([ ...departmentIds ]);
    }

    const  removeSelectedInstDepartment = (id) =>{
        let tempSelectedInstDept = selectedInstDept.filter(instId => instId != id)
        // if(tempSelectedInstDept.length < 0 )
        // {
        //     setNoticeInstDepartmentWarning('Please select at least one institute department to proceed.');

        // }
        setSelectedInstDept([...tempSelectedInstDept])

    }
    const confirmInstDepartmentSelection = () =>{
        // if(selectedInstDept.length == 0 )
        // {
        //     setNoticeInstDepartmentWarning('Please select at least one institute department to proceed.');

        // }
        // else
        // {
            setNoticeInstDepartmentWarning("")
        // }
        setSelectNoticeInstDepartment(false)

    }

    const cancelInstDepartmentSelection = () =>{
        setSelectedInstDept([])
        setNoticeInstDepartmentWarning("")

        // setNoticeInstDepartmentWarning('Please select at least one institute department to proceed.');
        setSelectNoticeInstDepartment(false)


    }

    const handleSelectInstDept = (id) =>{
        let tempSelectedInstDept=selectedInstDept
        if(!tempSelectedInstDept.includes(id))
        {

            tempSelectedInstDept.push(id)
        }
        else
        {
            tempSelectedInstDept = tempSelectedInstDept.filter(filterId => filterId !== id);
        }
        setSelectedInstDept([ ...tempSelectedInstDept ]);
         
    }

    // METHOD TO CONFIRM DEPARTMENT SELECTION
    const confirmDepartmentSelection = () => {
        let studentObject = studentAssigneeObject;
        let teachingObject = teachingAssigneeObject;
        let nonTeachingObject = nonTeachingAssigneeObject;
        if(tempNoticeDepartmentIds.length > 0) 
        {
            setSelectNoticeDepartment(false);
            setNoticeDepartmentIds(tempNoticeDepartmentIds);
            setDepartmentSelectionWarning('');
            setNoticeDepartmentWarning('');

            tempNoticeDepartmentIds.map(departmentId => {
                if(studentObject[departmentId] == undefined) {  
                    studentObject[departmentId] = {};
                }

                if(teachingObject[departmentId] == undefined) {
                    teachingObject[departmentId] = {};
                }

                if(nonTeachingObject[departmentId] == undefined) {
                    nonTeachingObject[departmentId] = {};
                }
                studentObject[departmentId]['departmentId'] = departmentId;
                studentObject[departmentId]['departmentName'] = categoryAssignedDepartment[departmentId].streamName;
                studentObject[departmentId]['collapsible'] = false;
                studentObject[departmentId]['searchKey'] = '';
                studentObject[departmentId]['groupDetails'] = {};
                
                teachingObject[departmentId]['departmentId'] = departmentId;
                teachingObject[departmentId]['departmentName'] = categoryAssignedDepartment[departmentId].streamName;
                teachingObject[departmentId]['collapsible'] = false;
                teachingObject[departmentId]['searchKey'] = '';
                teachingObject[departmentId]['facultyList'] = [];
                
                nonTeachingObject[departmentId]['departmentId'] = departmentId;
                nonTeachingObject[departmentId]['departmentName'] = categoryAssignedDepartment[departmentId].streamName;
                nonTeachingObject[departmentId]['collapsible'] = false;
                nonTeachingObject[departmentId]['searchKey'] = '';
                nonTeachingObject[departmentId]['facultyList'] = [];
            });

            setStudentAssigneeObject({ ...studentObject });
            setTeachingAssigneeObject({ ...teachingObject });
            setNonTeachingAssigneeObject({ ...nonTeachingObject });
        }else {
            setDepartmentSelectionWarning('Please select at least one department to proceed.');
        }
    }

    // METHOD TO CANCEL DEPARTMENT SELECTION
    const cancelDepartmentSelection = () => {
        let studentObject = studentAssigneeObject;
        let teachingObject = teachingAssigneeObject;
        let nonTeachingObject = nonTeachingAssigneeObject;
        setSelectNoticeDepartment(false);
        setTempNoticeDepartmentIds(noticeDepartmentIds);
        setDepartmentSelectionWarning('');

        if(noticeDepartmentIds > 0) {
            noticeDepartmentIds.map(departmentId => {
                if(studentObject[departmentId] == undefined) {
                    studentObject[departmentId] = {};
                }

                if(teachingObject[departmentId] == undefined) {
                    teachingObject[departmentId] = {};
                }

                if(nonTeachingObject[departmentId] == undefined) {
                    nonTeachingObject[departmentId] = {};
                }

                studentObject[departmentId]['departmentId'] = departmentId;
                studentObject[departmentId]['departmentName'] = categoryAssignedDepartment[departmentId].streamName;
                studentObject[departmentId]['collapsible'] = false;
                studentObject[departmentId]['searchKey'] = '';
                studentObject[departmentId]['groupDetails'] = {};
                
                teachingObject[departmentId]['departmentId'] = departmentId;
                teachingObject[departmentId]['departmentName'] = categoryAssignedDepartment[departmentId].streamName;
                teachingObject[departmentId]['collapsible'] = false;
                teachingObject[departmentId]['searchKey'] = '';
                teachingObject[departmentId]['facultyList'] = [];
                
                nonTeachingObject[departmentId]['departmentId'] = departmentId;
                nonTeachingObject[departmentId]['departmentName'] = categoryAssignedDepartment[departmentId].streamName;
                nonTeachingObject[departmentId]['collapsible'] = false;
                nonTeachingObject[departmentId]['searchKey'] = '';
                nonTeachingObject[departmentId]['facultyList'] = [];
            });

            setStudentAssigneeObject({ ...studentObject });
            setTeachingAssigneeObject({ ...teachingObject });
            setNonTeachingAssigneeObject({ ...nonTeachingObject });
        }else {
            setStudentAssigneeObject({});
            setTeachingAssigneeObject({});
            setNonTeachingAssigneeObject({});
        }
    }

    // METHOD TO REMOVE SELECTED DEPARTMENTS
    const removeSelectedDepartment = (streamId) => {
        let tempDepartments = tempNoticeDepartmentIds;
        let departments = noticeDepartmentIds;
        let studentObject = studentAssigneeObject;
        let teachingObject = teachingAssigneeObject;
        let nonTeachingObject = nonTeachingAssigneeObject;

        tempDepartments = tempDepartments.filter(id => id != streamId);
        departments = departments.filter(id => id != streamId);

        delete studentObject[streamId];
        delete teachingObject[streamId];
        delete nonTeachingObject[streamId];

        setTempNoticeDepartmentIds([ ...tempDepartments ]);
        setNoticeDepartmentIds([ ...departments ]);
        setStudentAssigneeObject({ ...studentObject });
        setTeachingAssigneeObject({ ...teachingObject });
        setNonTeachingAssigneeObject({ ...nonTeachingObject });
    }

    // METHOD TO VALIDATE BASIC DETAILS
    const validateBasicDetails = () => {
        let validData = true;

        if(noticeCategoryId?.length < 1) {
            setNoticeCategoryWarning('Please select notice category.');
            validData = false;
        }

        if(noticeTitle?.trim().length < 1) {
            setNoticeTitleWarning('Title cannot be empty.');
            validData = false;
        }
        
        if(addNoticeDescription?.length < 1) {
            setNoticeDescriptionWarning('Description cannot be empty.');
            validData = false;
        }

        if(noticeDateTime?.length < 1) {
            setNoticeDateTimeWarning('Please select date & time.');
            validData = false;
        }
    
        if(noticeAttachments?.length > 0) {//noticeDepartmentIds
            let sizeCount = 0;
            let extensionCount = 0;

            noticeAttachments.map(attachment => {
                if((attachment.size / 1048576.0) > 5) {
                    sizeCount = sizeCount + 1;
                }else if(!allowedFileExtensions.includes(attachment.name.substring(attachment.name.lastIndexOf('.') + 1))) {
                    extensionCount = extensionCount + 1;
                }
            });

            if(sizeCount > 0) 
            {
                setNoticeAttachmentWarning(`${sizeCount} out of ${noticeAttachments.length} file(s) selected with size more than 5MB.`);
                validData = false;
            }
            else if(extensionCount > 0) 
            {
                setNoticeAttachmentWarning(`${extensionCount} out of ${noticeAttachments.length} file(s) are not having extensions .jpeg, .jpg, .png, .pdf.`);
                validData = false;
            }
            else if((noticeAttachments?.length + addedAttachments?.length ) > 5) 
            {
                setNoticeAttachmentWarning(`You can select only 5 files.`);
                validData = false; 
            }
        }

        if(noticeAcademicYearId.length < 1) {
            setNoticeAcademicYearWarning('Please select academic year.');
            validData = false;
        }

        if(noticeDepartmentIds.length < 1) {
            setNoticeDepartmentWarning('Please select department.');
            validData = false;
        }
        // if(selectedInstDept.length <1)
        // {
        //     setNoticeInstDepartmentWarning('Please select institute department.');
        //     validData = false;

        // }

        if(validData) {
        // API CALL TO POST NOTICE
        if(editMode) {
            apiCallToUpdateNotice();
        }else {
                apiCallToPostNotice();
                setPostNoticeActiveTab(postNoticeActiveTab + 1);
    
                if(Object.keys(studentAssigneeObject).length > 0) {
                    Object.keys(studentAssigneeObject).map(departmentId => {
                        apiCallToGetGroupDetails(departmentId);
                    });
                }
            }
        }
    }

    // API CALL METHOD TO GET GROUP LIST
    const apiCallToGetGroupDetails = async (departmentId) => {
        setStudent(true)
        let requestData = {
            'iid': config.institute_id,
            'yearId': noticeAcademicYearId,
            'sidArray': [departmentId]
        }

        let jsonResponse = await NoticeboardAPICall.makeApiCall(
            "GetStreamWiseGroupDetails",
            requestData,
            '/api/admission/groupDetails.php'
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                apiCallToGetGroupDetails(departmentId);
            }, 1000);
        } else {
            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult.data;
                let studentObject = studentAssigneeObject;

                if(studentObject[departmentId].groupDetails == undefined) {
                    studentObject[departmentId].groupDetails = {};
                }

                studentObject[departmentId].groupDetails = apiResult[departmentId].groups == undefined ? {} : apiResult[departmentId].groups;

                setStudentAssigneeObject({ ...studentObject });
                setStudent(false)

            }
        }


    }

    // METHOD TO SELECT ASSIGNEE TAB
    const selectAssigneeTab = (tab) => {
        if(tab.tabName == 'TEACHING') {
            if(Object.keys(teachingAssigneeObject).length > 0) {
                Object.keys(teachingAssigneeObject).map(departmentId => {
                    if(teachingAssigneeObject[departmentId].facultyList.length == 0) {
                        apiCallToGetFacultyList(teachingAssigneeObject[departmentId].searchKey, departmentId, 'teaching');
                    }
                });
            }
        }else if(tab.tabName == 'NON-TEACHING'){
            if(Object.keys(nonTeachingAssigneeObject).length > 0) {
                Object.keys(nonTeachingAssigneeObject).map(departmentId => {
                    if(nonTeachingAssigneeObject[departmentId].facultyList.length == 0) {
                        apiCallToGetFacultyList(nonTeachingAssigneeObject[departmentId].searchKey, departmentId, 'nonteaching');
                    }
                });
            }
        }else if(tab.tabName == 'STUDENTS'){
            if(Object.keys(studentAssigneeObject).length > 0) {
                Object.keys(studentAssigneeObject).map(departmentId => {
                    if(Object.keys(studentAssigneeObject[departmentId].groupDetails).length == 0) {
                        apiCallToGetGroupDetails(departmentId);
                    }
                });
            }
        }

        setAssigneeTab(tab.tabName);
    }

    // API CALL METHOD TO GET FACULTY LIST
    const apiCallToGetFacultyList = async (search, departmentId, type) => {
        if(type == 'teaching') {
            setTeaching(true)
        }
        else{
            setNonTeaching(true)
        }
        let requestData = {
            "iid": config.institute_id,
            "type": "all",
            "page_index": 1,
            "limit": 1000,
            "status": "0",
            "role": type,
            "search": search,
            "selectedStream": departmentId,
            "selectedDepartment": 0
        };

        let jsonResponse = await NoticeboardAPICall.makeApiCall(
            "getFacultyList",
            requestData,
            '/api/instructor/facultyRegistration.php'
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                apiCallToGetFacultyList(departmentId, type);
            }, 1000);
        } else {
            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult.data;
                let teachingObject = teachingAssigneeObject;
                let nonTeachingObject = nonTeachingAssigneeObject;

                if(type == 'teaching') {
                    teachingObject[departmentId]['facultyList'] = apiResult.length > 0 ? apiResult : [];
                    setTeaching(false)
                }else {
                    nonTeachingObject[departmentId]['facultyList'] = apiResult.length > 0 ? apiResult : [];
                    setNonTeaching(false)
                }
                setTeachingAssigneeObject({ ...teachingObject });
                setNonTeachingAssigneeObject({ ...nonTeachingObject });
            }
        }
    }

    // METHOD TO COLLAPSE STUDENT DEPARTMENT
    const collapseStudentDepartment = (departmentId) => {
        let studentObject = studentAssigneeObject;

        studentObject[departmentId].collapsible = !studentObject[departmentId].collapsible;

        setStudentAssigneeObject({ ...studentObject });
    }

    // METHOD TO COLLAPSE TEACHING DEPARTMENT
    const collapseTeachingDepartment = (departmentId) => {
        let teachingObject = teachingAssigneeObject;

        teachingObject[departmentId].collapsible = !teachingObject[departmentId].collapsible;

        setTeachingAssigneeObject({ ...teachingObject });
    }

    // METHOD TO COLLAPSE NON TEACHING DEPARTMENT
    const collapseNonTeachingDepartment = (departmentId) => {
        let nonTeachingObject = nonTeachingAssigneeObject;

        nonTeachingObject[departmentId].collapsible = !nonTeachingObject[departmentId].collapsible;

        setNonTeachingAssigneeObject({ ...nonTeachingObject });
    }

    // METHOD TO GET SEARCH TERM
    // const getSearchTerm = (e, departmentId, type) => {
    //     let teachingObject = teachingAssigneeObject;
    //     let nonTeachingObject = nonTeachingAssigneeObject;

    //     if(type == 'teaching') {
    //         teachingObject[departmentId].searchKey = e.target.value;
    //         setTeachingAssigneeObject({ ...teachingObject });
    //     }else {
    //         nonTeachingObject[departmentId].searchKey = e.target.value;
    //         setNonTeachingAssigneeObject({ ...nonTeachingObject });
    //     }
    // }

    // METHOD TO GET SEARCH EMPLOYEE
    // const searchFaculty = (e, department, type) => {
    //     if(e.charCode == 13) {
    //         if(type == 'teaching') {
    //             apiCallToGetFacultyList(department.searchKey, department.departmentId, type);
    //         }else {
    //             apiCallToGetFacultyList(department.searchKey, department.departmentId, type);
    //         }
    //     }
    // }

    // METHOD TO SELECT TEACHING FACULTY
    const selectTeachingFaculty = (departmentId, facultyId) => {
        let selectedFaculty = selectedTeachingFaculty;
        let assigneeObject = assigneesDetails;

        if(selectedFaculty[departmentId] == undefined) {
            selectedFaculty[departmentId] = [];
        }

        if(selectedFaculty[departmentId].includes(facultyId)) {
            selectedFaculty[departmentId] = selectedFaculty[departmentId].filter(id => id != facultyId);
        }else {
            selectedFaculty[departmentId].push(facultyId);
        }

        if(selectedFaculty[departmentId].length > 0) {
            if(assigneeObject['teaching'][departmentId] == undefined) {
                assigneeObject['teaching'][departmentId] = [];
            }
    
            assigneeObject.teaching[departmentId] = selectedFaculty[departmentId];
        }else {
            delete selectedFaculty[departmentId];
            
            if(assigneeObject.teaching[departmentId] != undefined) {
                delete assigneeObject.teaching[departmentId];
            }
        }

        setSelectedTeachingFaculty({ ...selectedFaculty });
        setAssigneeDetails({ ...assigneeObject });
    }

    // METHOD TO SELECT NON TEACHING FACULTY
    const selectNonTeachingFaculty = (departmentId, facultyId) => {
        let selectedFaculty = selectedNonTeachingFaculty;
        let assigneeObject = assigneesDetails;

        if(selectedFaculty[departmentId] == undefined) {
            selectedFaculty[departmentId] = [];
        }

        if(selectedFaculty[departmentId].includes(facultyId)) {
            selectedFaculty[departmentId] = selectedFaculty[departmentId].filter(id => id != facultyId);
        }else {
            selectedFaculty[departmentId].push(facultyId);
        }

        if(selectedFaculty[departmentId].length > 0) {

            if(assigneeObject['non_teaching'][departmentId] == undefined) {
                assigneeObject['non_teaching'][departmentId] = [];
            }

            assigneeObject['non_teaching'][departmentId] = selectedFaculty[departmentId];
        }else {
            delete selectedFaculty[departmentId];
            
            if(assigneeObject['non_teaching'][departmentId] != undefined) {
                delete assigneeObject['non_teaching'][departmentId];
            }
        }

        setSelectedNonTeachingFaculty({ ...selectedFaculty });
        setAssigneeDetails({ ...assigneeObject });
    }

    // METHOD TO SELECT ALL STUDENT DEPARTMENTS
    const selectAllStudentDepartments = (e) => {
        let assigneeData = assigneesDetails;

        if(e.target.checked) {
            if(Object.keys(studentAssigneeObject).length > 0) {
                Object.keys(studentAssigneeObject).map(departmentId => {
                    if(assigneeData.student[departmentId] == undefined) {
                        assigneeData.student[departmentId] = {};
                    }

                    if(Object.keys(studentAssigneeObject[departmentId].groupDetails).length > 0) {
                        Object.keys(studentAssigneeObject[departmentId].groupDetails).map(groupId => {
                            if(assigneeData.student[departmentId][groupId] == undefined) {
                                assigneeData.student[departmentId][groupId] = '';
                            }
                            assigneeData.student[departmentId][groupId] = 'all';
                        });
                    }
                });
            }
        }else {
            assigneeData.student = {};
        }

        setAssigneeDetails({ ...assigneeData });
    }

    // METHOD TO SELECT SINGLE STUDENT DEPARTMENTS
    const selectSingleStudentDepartment = (e, departmentId) => {
        let assigneeData = assigneesDetails;

        if(e.target.checked) {
            if(assigneeData.student[departmentId] == undefined) {
                assigneeData.student[departmentId] = {};
            }

            if(Object.keys(studentAssigneeObject[departmentId].groupDetails).length > 0) {
                Object.keys(studentAssigneeObject[departmentId].groupDetails).map(groupId => {
                    if(assigneeData.student[departmentId][groupId] == undefined) {
                        assigneeData.student[departmentId][groupId] = '';
                    }
                    assigneeData.student[departmentId][groupId] = 'all';
                });
            }
        }else {
            delete assigneeData.student[departmentId];
        }

        setAssigneeDetails({ ...assigneeData });
    }

    // METHOD TO SELECT SINGLE GROUP
    const selectSingleGroup = (e, departmentId, groupId) => {
        let assigneeObject = assigneesDetails;
        
        if(e.target.checked) {
            if(assigneeObject.student[departmentId] == undefined) {
                assigneeObject.student[departmentId] = {};
            }

            if(assigneeObject.student[departmentId][groupId] == undefined) {
                assigneeObject.student[departmentId][groupId] = '';
            }
            assigneeObject.student[departmentId][groupId] = 'all';
        }else {
            delete assigneeObject.student[departmentId][groupId];
        }

        setAssigneeDetails({ ...assigneeObject });
    }

    // METHOD TO SELECT ALL TEACHING DEPARTMENTS
    const selectAllTeachingDepartments = (e) => {
        let assigneeData = assigneesDetails;
        let selectedFaculty = selectedTeachingFaculty;
        if(e.target.checked) {
            if(Object.keys(teachingAssigneeObject).length) {
                Object.keys(teachingAssigneeObject).map(departmentId => {
                    let selectedFacultySet = new Set(); 
                    if(assigneeData.teaching[departmentId] == undefined) {
                        assigneeData.teaching[departmentId] = 'all';
                    }

                    if(selectedFaculty[departmentId] == undefined) {
                        selectedFaculty[departmentId] = [];
                    }

                    if(teachingAssigneeObject[departmentId].facultyList.length > 0) {
                        teachingAssigneeObject[departmentId].facultyList.map(faculty => {
                            selectedFacultySet.add(faculty.faculty_id);
                        });
                    }

                    selectedFaculty[departmentId] = Array.from(selectedFacultySet);
                });
            }
        }else {
            assigneeData.teaching = {};
            selectedFaculty = {};
        }

        setAssigneeDetails({ ...assigneeData });
        setSelectedTeachingFaculty({ ...selectedFaculty });
    }

    // METHOD TO SELECT SINGLE TEACHING DEPARTMENTS
    const selectSingleTeachingDepartment = (e, departmentId) => {
        let assigneeData = assigneesDetails;
        let selectedFaculty = selectedTeachingFaculty;
        let selectedFacultySet = new Set();

        if(e.target.checked) {
            if(assigneeData.teaching[departmentId] == undefined) {
                assigneeData.teaching[departmentId] = 'all';
            }

            if(selectedFaculty[departmentId] == undefined) {
                selectedFaculty[departmentId] = [];
            }

            if(teachingAssigneeObject[departmentId].facultyList.length > 0) {
                teachingAssigneeObject[departmentId].facultyList.map(faculty => {
                    selectedFacultySet.add(faculty.faculty_id);
                });
            }

            selectedFaculty[departmentId] = Array.from(selectedFacultySet);
        }else {
            delete assigneeData.teaching[departmentId];
            delete selectedFaculty[departmentId];
        }

        setAssigneeDetails({ ...assigneeData });
        setSelectedTeachingFaculty({ ...selectedFaculty });
    }

    // METHOD TO SELECT ALL NON-TEACHING DEPARTMENTS
    const selectAllNonTeachingDepartments = (e) => {
        let assigneeData = assigneesDetails;
        let selectedFaculty = selectedNonTeachingFaculty;

        if(e.target.checked) {
            if(Object.keys(nonTeachingAssigneeObject).length) {
                Object.keys(nonTeachingAssigneeObject).map(departmentId => {
                    let selectedFacultySet = new Set(); 
                    if(assigneeData.non_teaching[departmentId] == undefined) {
                        assigneeData.non_teaching[departmentId] = 'all';
                    }

                    if(selectedFaculty[departmentId] == undefined) {
                        selectedFaculty[departmentId] = [];
                    }

                    if(nonTeachingAssigneeObject[departmentId].facultyList.length > 0) {
                        nonTeachingAssigneeObject[departmentId].facultyList.map(faculty => {
                            selectedFacultySet.add(faculty.faculty_id);
                        });
                    }

                    selectedFaculty[departmentId] = Array.from(selectedFacultySet);
                });
            }
        }else {
            assigneeData.non_teaching = {};
            selectedFaculty = {};
        }

        setAssigneeDetails({ ...assigneeData });
        setSelectedNonTeachingFaculty({ ...selectedFaculty });
    }

    // METHOD TO SELECT SINGLE NON-TEACHING DEPARTMENTS
    const selectSingleNonTeachingDepartment = (e, departmentId) => {
        let assigneeData = assigneesDetails;
        let selectedFaculty = selectedNonTeachingFaculty;
        let selectedFacultySet = new Set();

        if(e.target.checked) {
            if(assigneeData.non_teaching[departmentId] == undefined) {
                assigneeData.non_teaching[departmentId] = 'all';
            }

            if(selectedFaculty[departmentId] == undefined) {
                selectedFaculty[departmentId] = [];
            }

            if(nonTeachingAssigneeObject[departmentId].facultyList.length > 0) {
                nonTeachingAssigneeObject[departmentId].facultyList.map(faculty => {
                    selectedFacultySet.add(faculty.faculty_id);
                });
            }

            selectedFaculty[departmentId] = Array.from(selectedFacultySet);
        }else {
            delete assigneeData.non_teaching[departmentId];
            delete selectedFaculty[departmentId];
        }

        setAssigneeDetails({ ...assigneeData });
        setSelectedNonTeachingFaculty({ ...selectedFaculty });
    }

    // API CALL METHOD TO POST NOTICE
    const apiCallToPostNotice = async () => {
        setPostingNotice(true);

        let requestData = {
            "institute_id": config.institute_id,
            "title": noticeTitle,
            "description": addNoticeDescription,
            "category_id": noticeCategoryId,
            "categorySeries" : searchCategorySeries,
            "department_array": noticeDepartmentIds,
            "institute_departmentId_array":selectedInstDept,
            "noticeDateTime": noticeDateTime.split('T')[0] + ' ' + noticeDateTime.split('T')[1],
            "aca_yr": noticeAcademicYearId,
            "display_on_website": displayOnWebsite,
            "posted_by": config.faculty_id,
            "assigneeAcademicYear": noticeAcademicYearId,
            "assigneeObject": assigneesDetails,
            "sendNotification": notifyOnMobile ? "true" : "false"
        };
        
        let formData = new FormData();

        formData.append('postNotice', true);

        formData.append('data',Base64.encode(JSON.stringify(requestData)));

        if(noticeAttachments.length > 0) {
            noticeAttachments.map(attachment => {
                formData.append('file[]', attachment);
            });
        }

        let parameterData = JSON.stringify({
            source: 'app',
            uid: config.faculty_id,
            email: config.emailId,
            role: 'instructor'
        });

        formData.append('tokenInputParameter', Base64.encode(parameterData));

        const headers = {
            Accept: "application/json",
            "Content-Type": "multipart/form-data",
            "Authorization": "Basic " + config.user_token
        };

        await axios.post(
            config.RootUrl + '/api/notice/notice.php',
            formData,
            {
                headers: headers,
            }
        ).then((response)=> {
            if (response.data.success) {
                if (response.data.status == "success") {
                    toast.success(response.data.message);
                    setNoticeId(response.data.noticeId);
                    setPostingNotice(false);
                    noticeAdded();
                //  closePostNotice();
                }else {
                    toast.warning(response.data.message);
                    setPostingNotice(false);
                }
            }else {
                toast.error('Something went wrong while posting notice. Please try again later.')
                setPostingNotice(false);
            }
        });
    }
    // METHOD FOR ADD NOTICE ASSIGNEE API CALL
	const apiCallToGetAddNoticeRoleWiseAssignee = async () => {
        setAssignAssignee(true);
		let formData = {
			"institute_id": config.institute_id,
			"assigneeObject": assigneesDetails,
			"notice_id": noticeId,
			"addedBy": config.faculty_id,
			"aca_yr": noticeAcademicYearId
		}
		let jsonResponse = await NoticeboardAPICall.makeApiCall(
			'addNoticeRoleWiseAssignee',
			 formData,
			'/api/notice/notice.php'
		);
		if (jsonResponse.expired) {
			setTimeout(() => {
				apiCallToGetAddNoticeRoleWiseAssignee();
			}, 1000);
		} else {
			if (jsonResponse.success) {
				let apiResult = await jsonResponse.APIResult.data;
                toast.success(jsonResponse.APIResult.message)
                closePostNotice();
                setAssignAssignee(false);
			} else {
                setAssignAssignee(false);
                toast.error("Something went wrong while adding notice. Please try again later.")
			}
		}
	}

    // VALIDATION METHOD TO BEFORE ASSIGN ASSIGNEE
    const validationToAssignAssignee = async () => {
        let roles = Object.keys(assigneesDetails);
        let valid = false; 

        roles.forEach(role => {
            let assignee = assigneesDetails[role];
            if (Object.keys(assignee).length > 0) 
            { 
                valid = true;
            }
        });
    
        if (valid) 
        {
           apiCallToGetAddNoticeRoleWiseAssignee();
        } 
        else 
        {
            toast.warn("Please select assignee.");
        }
    };
    

    // API CALL METHOD TO UPDATE NOTICE
    const apiCallToUpdateNotice = async () => {
        setPostingNotice(true);

        let requestData = {
            "institute_id": config.institute_id,
            "unique_id": noticeUniqueId,
            "title": noticeTitle,
            "description": addNoticeDescription,
            'category_id': noticeCategoryId,
            "lastCategory_id" : last_noticeCategoryId,
            "categorySeries" : searchCategorySeries,
            "noticeDateTime": noticeDateTime.split('T')[0] + ' ' + noticeDateTime.split('T')[1],
            "department_array": noticeDepartmentIds,
            "instituteDeptIdArray": selectedInstDept,
            "aca_yr": noticeAcademicYearId,
            "display_on_website": displayOnWebsite,
            "posted_by": config.faculty_id,
            "removeAttachmentArray": removedAttachmentArray
        };
        
        let formData = new FormData();

        formData.append('updateNotice', true);

        formData.append('data',Base64.encode(JSON.stringify(requestData)));

        if(noticeAttachments.length > 0) {
            noticeAttachments.map(attachment => {
                formData.append('file[]', attachment);
            });
        }

        let parameterData = JSON.stringify({
            source: 'app',
            uid: config.faculty_id,
            email: config.emailId,
            role: 'instructor'
        });

        formData.append('tokenInputParameter', Base64.encode(parameterData));

        const headers = {
            Accept: "application/json",
            "Content-Type": "multipart/form-data",
            "Authorization": "Basic " + config.user_token
        };

        await axios.post(
            config.RootUrl + '/api/notice/notice.php',
            formData,
            {
                headers: headers,
            }
        ).then((response)=> {
            if (response.data.success) {
                if (response.data.status == "success") {
                    let noticeObject = noticeList;
                    let noticeDepartmentArray = [];

                    noticeDepartmentIds.map(departmentId => {
                        if(categoryAssignedDepartment[departmentId] != undefined) {
                            noticeDepartmentArray.push(categoryAssignedDepartment[departmentId].streamName);
                        }
                    });

                    noticeObject[noticeUniqueId]['PublicLink'] = noticeObject[noticeUniqueId]['PublicLink'];
                    noticeObject[noticeUniqueId]['academicYear'] = noticeAcademicYear;
                    noticeObject[noticeUniqueId]['academicYearId'] = noticeAcademicYearId;
                    noticeObject[noticeUniqueId]['addedBy'] = noticeObject[noticeUniqueId]['addedBy'];
                    noticeObject[noticeUniqueId]['addedOn'] = noticeObject[noticeUniqueId]['addedOn'];
                    noticeObject[noticeUniqueId]['addedById'] = noticeObject[noticeUniqueId]['addedById'];
                    noticeObject[noticeUniqueId]['assigneeCount'] = noticeObject[noticeUniqueId]['assigneeCount'];
                    noticeObject[noticeUniqueId]['attachment'] = response.data.attachments ? response.data.attachments.attachments.join(',') : (noticeObject[noticeUniqueId]['attachment']);
                    noticeObject[noticeUniqueId]['attachmentPath'] = response.data.attachments ? response.data.attachments.filePath : noticeObject[noticeUniqueId]['attachmentPath'];
                    noticeObject[noticeUniqueId]['bookmarkStatus'] = noticeObject[noticeUniqueId]['bookmarkStatus'];
                    noticeObject[noticeUniqueId]['categoryId'] = noticeCategoryId;
                    noticeObject[noticeUniqueId]['categoryName'] = noticeCategoryName;
                    noticeObject[noticeUniqueId]['department'] = noticeDepartmentArray.join(',');
                    noticeObject[noticeUniqueId]['departmentIdArray'] = noticeDepartmentIds;
                    noticeObject[noticeUniqueId]['description'] = ReactHtmlParser(addNoticeDescription);
                    noticeObject[noticeUniqueId]['formattedNoticeDate'] = formatDate(noticeDateTime.split('T')[0]) + ' | ' + moment(noticeDateTime.split('T')[1]).format('HH:mm a');
                    noticeObject[noticeUniqueId]['noticeDate'] = noticeDateTime.split('T')[0] + ' ' + noticeDateTime.split('T')[1];
                    noticeObject[noticeUniqueId]['noticeId'] = noticeUniqueId;
                    noticeObject[noticeUniqueId]['readDate'] = noticeObject[noticeUniqueId]['readDate'];
                    noticeObject[noticeUniqueId]['readStatus'] = noticeObject[noticeUniqueId]['readStatus'];
                    noticeObject[noticeUniqueId]['readTime'] = noticeObject[noticeUniqueId]['readTime'];
                    noticeObject[noticeUniqueId]['title'] = noticeTitle;
                    noticeObject[noticeUniqueId]['totalViews'] = noticeObject[noticeUniqueId]['totalViews'];
                    noticeObject[noticeUniqueId]['updatedBy'] = noticeObject[noticeUniqueId]['updatedBy'];
                    noticeObject[noticeUniqueId]['updatedOn'] = noticeObject[noticeUniqueId]['updatedOn'];
                    setNoticeList({ ...noticeObject });
                    // getMessage(response.data.message);
                    toast.success( response.data.message)
                    setPostingNotice(false);
                    closePostNotice();
                }else {
                    toast.warning( response.data.message)
                    setPostingNotice(false);
                }
            }else {
                toast.error("Something went wrong while updating notice. Please try again later.")
                setPostingNotice(false);
            }
        });
    }

    // METHOD TO CLOSE POST NOTICE
    const closePostNotice = () => {
        setPostNotice(false);
        setNoticeCategoryId('');
        setTempNoticeCategoryId('');
        setSelectedInstDept([]);
        setNoticeCategoryName('');
        setTempNoticeCategoryName('');
        setCategorySelectionWarning('');
        setNoticeCategoryWarning('');
        setNoticeTitle('');
        setNoticeTitleWarning('');
        setAddNoticeDescription('');
        setNoticeDescriptionWarning('');
        setNoticeDateTime('');
        setNoticeDateTimeWarning('');
        setNoticeAttachment([]);
        setNoticeAttachmentWarning('');
        setNoticeAcademicYearId('');
        setNoticeAcademicYear('');
        setNoticeAcademicYearWarning('');
        setSelectNoticeDepartment(false);
        setNoticeDepartment('');
        setTempNoticeDepartmentIds([]);
        setNoticeDepartmentIds([]);
        setNoticeDepartmentWarning('');
        setDepartmentSelectionWarning('');
        setDisplayOnWebsite(false);
        setNotifyOnMobile(false);
    }

    // METHOD TO FORMAT DATE
    const formatDate = (d) =>{
        var date = new Date(d);

        if (isNaN(date.getTime())) {
            return "";
        }else{  
            var month = new Array();
            month[0] = "Jan";
            month[1] = "Feb";
            month[2] = "Mar";
            month[3] = "Apr";
            month[4] = "May";
            month[5] = "Jun";
            month[6] = "Jul";
            month[7] = "Aug";
            month[8] = "Sep";
            month[9] = "Oct";
            month[10] = "Nov";
            month[11] = "Dec";

            let day = date.getDate();
            
            if(day < 10) {
                day = "0"+day;
            }
            return day  + " " +month[date.getMonth()] + ", " + date.getFullYear();
        }       
    }

    // METHOD TO CLOSE WARNING MODAL
    const closeSuccessModal = () => {
        setSuccessModalDetails({
            successModal: false,
            successModalType: "",
            successMessage: ""
        });
    }
    // GET DATA FROM EDITOR
	const getNoticeDescription = (data) => {
        setAddNoticeDescription(data)
    };

    return (
        <>
            <div className="postNoticeSidebar">
                <div className="postNoticeSidebarContainer">
                    <div className="sideBarHeader d-flex justify-content-center align-items-center">
                        <div style={ { cursor: "pointer" } }>
                            <Close
                                className="mx-2 pointer"
                                onClick={() => closePostNotice()}
                            />
                        </div>
                        <div className="p-1 flex-grow-1 text-center">
                            <p>{ editMode ? 'Update Notice' : 'Post Notice' }</p>
                        </div>
                    </div>
                    <div className="row">
                        {
                            !editMode && 
                                <div className='col-12'>
                                    <div className='postNoticeTabIconDiv'>
                                        {
                                            postNoticeTabArray.map((tab, index) => {
                                                return(
                                                    <div className='flexColumn'>
                                                        <div className={ index === postNoticeActiveTab ? 'activeTabCircle' : 'tabCircle' }>{ tab.iconName }</div>
                                                        <div className={ index === postNoticeActiveTab ? 'activeTabName' : 'tabName' }>{ tab.tabName }</div>
                                                    </div>
                                                );
                                            })
                                        }
                                    </div>
                                </div> 
                        }
                        {
                            (editMode || postNoticeActiveTab === 0) && 
                                <div className={editMode ? "col-12 p-0 editNoticeTab form-group" : "col-12 p-0 postNoticeTab form-group"} style={ { fontSize: '14px' } }>
                                    <div className="row">
                                        <div className="col-md-12 p-2">
                                            <label className="normalBoldFont">
                                                Category<span className="text-danger ml-1">*</span>
                                            </label>
                                            <br />
                                            {
                                                 categoryFetching ?
                                                 <ButtonLoader/>
                                                 :
                                                <input
                                                    className="form-control postNoticeInput"
                                                    value={noticeCategoryName}
                                                    type="text"
                                                    placeholder="Click here to select category"
                                                    onClick={() => selectNoticeCategory()}
                                                    readOnly
                                                />
                                            }
                                            <p className='text-danger' style={ { fontSize: 12 } } >{noticeCategoryWarning}</p>
                                        </div>
                                        <div className="col-md-12 p-2">
                                            <label className="normalBoldFont">
                                                Notice Title<span className="text-danger ml-1">*</span>
                                            </label>
                                            <input
                                                className="form-control postNoticeInput"
                                                type="text"
                                                placeholder="Enter notice title"
                                                value={noticeTitle}
                                                onChange={(e) => getNoticeTitle(e)}
                                                maxLength='250'
                                            />
                                            <div className='py-0 d-flex justify-content-end smallFont secondaryColor'>Maximum 250 characters are allowed.</div>
                                            <p className='text-danger' style={ { fontSize: 12 } } >{noticeTitleWarning}</p>
                                        </div>
                                        <div className="col-md-12 p-2">
                                            <label className="normalBoldFont">
                                                Notice Description<span className="text-danger ml-1">*</span>
                                            </label>
                                            {
                                                froalaKeyAvailable &&

                                                <FroalaEditor
                                                    model={addNoticeDescription}
                                                    onModelChange={getNoticeDescription}
                                                    config={{
                                                        height: 400,
                                                        key: froala_auth_key,
                                                        attribution: false, // Disable Froala attribution
                                                        zIndex: 1,
                                                        toolbarButtons: [
                                                            'undo', 'redo', '|', 'bold', 'italic', 'underline', 'strikeThrough', 'subscript', 'superscript', '|',
                                                            'fontFamily', 'fontSize', 'color', '|', 'align', 'formatOL', 'formatUL', 'outdent', 'indent', '|',
                                                            'insertLink', 'insertImage', 'insertVideo', 'insertFile', 'insertTable', '|', 'clearFormatting', '|', 'html',
                                                            '|', 'tableInsertRowAfter', 'tableInsertRowBefore', 'tableInsertColumnAfter', 'tableInsertColumnBefore',
                                                            'tableDeleteRow', 'tableDeleteColumn', 'textColor'
                                                        ],
                                                        pluginsEnabled: ['tooltips',
                                                            'align', 'codeBeautifier', 'codeView', 'colors', 'draggable', 'emoticons', 'fontSize', 'fullscreen',
                                                            'image', 'link', 'lists', 'paragraphFormat', 'paragraphStyle', 'quickInsert', 'table', 'url', 'wordPaste'
                                                        ],
                                                        placeholderText: 'Edit Your Content Here!',
                                                        quickInsertTags: [''],

                                                        charCounterCount: true,

                                                    }}
                                                />
                                            }
                                            <div className='py-0 d-flex justify-content-end smallFont secondaryColor'>Maximum 1500 characters are allowed.</div>
                                            <p className='text-danger' style={ { fontSize: 12 } } >{noticeDescriptionWarning}</p>
                                        </div>
                                        <div className="col-md-12 p-2">
                                            <label className="normalBoldFont" style={{ textTransform: 'none' }}>
                                                Date and Time<span className="text-danger ml-1">*</span>
                                            </label>
                                            <br />
                                            <input
                                                className="col-12  form-control postNoticeInput"
                                                type="datetime-local"
                                                id="select date"
                                                name="birthday"
                                                value={noticeDateTime}
                                                onChange={(e) => getNoticeDateTime(e)}
                                            />
                                            <p className='text-danger' style={ { fontSize: 12 } } >{noticeDateTimeWarning}</p>
                                        </div>
                                        <div className='row'>
                                            <div className='smallFont col-12 p-2'><label style={ { fontWeight: 'bold' } }>Attachment</label> {!editMode && '(You can add 5 files at a time.)'}</div>
                                            {
                                                addedAttachments.length > 0 &&
                                                    <div className="addedAttachment-container p-2">
                                                        {
                                                            addedAttachments.map(attachment => {
                                                                if(attachment != '') 
                                                                {
                                                                    return(
                                                                        <div className="added-attachment">
                                                                            <p>{attachment}</p>
                                                                            <div class="dropdown">
                                                                                <FontAwesomeIcon icon={['fas', 'times']} style={{ marginLeft: 5 }} color="red" data-toggle="dropdown" />
                                                                                <div class="dropdown-menu attachment-menu" aria-labelledby="dropdownMenuButton">
                                                                                    <p style={{ fontSize: 12 }}>Are you sure you want to remove this attachment?</p>
                                                                                    <div className="attachment-buttons">
                                                                                        <button className="btn primary-button attachment-button" onClick={() => removeAddedAttachment(attachment)}>Yes</button>
                                                                                        <button className="btn outline-button attachment-button">No</button>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    );
                                                                }
                                                            })
                                                        }
                                                    </div>
                                            }
                                            <div className='col-12 px-1'>
                                                <label onClick={() => getAttachmentClick()} className="btn btn-light px-2 py-1 shadow-none">
                                                    Choose Files
                                                </label>
                                            </div>
                                            <div className="attachmentList col-md-12">
                                                {
                                                    noticeAttachments.length > 0 &&
                                                        noticeAttachments.map((attachment, attachmentIndex) => {
                                                            return(
                                                                <div className="attachmentName">
                                                                    <p>{attachment.name}</p>
                                                                    <FontAwesomeIcon icon={['fas', 'times']} style={{ marginLeft: 10, color: 'red', cursor: 'pointer' }} onClick={() => removeSelectedAttachment(attachmentIndex)} />
                                                                </div>
                                                            );
                                                        })
                                                }
                                            </div>
                                            <div className="col-12 warningMessage">
                                                {noticeAttachmentWarning}
                                            </div>
                                            <div className="col-md-12 p-2">
                                                <input
                                                    type="file"
                                                    id="attachment-files"
                                                    onChange={(e) => getAttachmentFiles(e)}
                                                    onClick={(e) => e.target.value = ''}
                                                    style={{ display: "none" }}
                                                    accept=".pdf, .jpeg, .jpg, .png"
                                                    multiple 
                                                />
                                            </div>
                                            <div className='col-12 smallFont'>
                                                Only pdf, jpg, jpeg, png type of file allowed.
                                            </div>
                                            <div className='col-12 smallFont'>
                                                Maximum file size is 5mb.
                                            </div>
                                        </div>
                                        <div className="col-md-12 p-2">
                                            <label className="normalBoldFont">
                                                Academic Year<span className="text-danger ml-1">*</span>
                                            </label>
                                            <br />
                                            <select className="w-100  form-control postNoticeInput" style={{ outline: "none", padding: "2px" }} onChange={(e) => selectNoticeAcademicYear(e)} value={noticeAcademicYearId}>
                                                <option value=''>Select Academic Year</option>
                                                { 
                                                    academicYearList && academicYearSortedArr &&

                                                        academicYearSortedArr?.map((streamId) => {
                                                            return (
                                                                <option key={streamId} value={streamId}>{academicYearList[streamId].year_text}</option>
                                                            );
                                                        })
                                                }
                                            </select>
                                            <p className='text-danger' style={ { fontSize: 12 } } >{noticeAcademicYearWarning}</p>
                                        </div>
                                        <div className="col-md-12 p-2">
                                            <label className="normalBoldFont">
                                                Department<span className="text-danger ml-1">*</span>
                                            </label>
                                            <br />
                                            <input
                                                className="form-control postNoticeInput"
                                                type="text"
                                                placeholder="Click here to select department"
                                                onClick={() => setSelectNoticeDepartment(true)}
                                                readOnly
                                            />
                                            <p style={{ fontSize: 12 }} className="text-danger">{noticeDepartmentWarning}</p>
                                            {
                                                (noticeDepartmentIds.length > 0 && Object.keys(categoryAssignedDepartment).length > 0) &&
                                                    noticeDepartmentIds.map(departmentId => {
                                                        return(
                                                            <div className="selectedDepartment">
                                                                <p>{categoryAssignedDepartment[departmentId] != undefined && categoryAssignedDepartment[departmentId].streamName}</p>
                                                                <FontAwesomeIcon icon={['fas', 'times']} style={{ cursor: 'pointer', marginLeft: 10, color: 'red' }} onClick={() => removeSelectedDepartment(departmentId)} />
                                                            </div>
                                                        );
                                                    })
                                            }
                                        </div>
                                        <div className="col-md-12 p-2">
                                            <label className="normalBoldFont">
                                                Institute Department
                                                {/* <span className="text-danger ml-1">*</span> */}
                                            </label>
                                            <br />
                                            <input
                                                className="form-control postNoticeInput"
                                                type="text"
                                                placeholder="Click here to select institute department"
                                                onClick={() => setSelectNoticeInstDepartment(true)}
                                                readOnly
                                            />
                                            <p style={{ fontSize: 12 }} className="text-danger">{noticeInstDepartmentWarning}</p>
                                            {
                                                (selectedInstDept.length > 0 && Object.keys(instituteDepartment).length > 0) &&
                                                    selectedInstDept.map(instDepartmentId => {
                                                        return(
                                                            <div className="selectedDepartment">
                                                                <p>{instituteDepartment[instDepartmentId] != undefined && instituteDepartment[instDepartmentId]["name"]}</p>
                                                                <FontAwesomeIcon icon={['fas', 'times']} style={{ cursor: 'pointer', marginLeft: 10, color: 'red' }} onClick={() => removeSelectedInstDepartment(instDepartmentId)} />
                                                            </div>
                                                        );
                                                    })
                                            }
                                        </div>
                                    </div>
                                    <div className="col-md-12 p-2">
                                        <div className="form-check">
                                            <input
                                                className="form-check-input"
                                                type="checkbox"
                                                id="flexCheckDefault"
                                                checked={displayOnWebsite}
                                                onChange={(e) => setDisplayOnWebsite(e.target.checked)}

                                            />
                                            <span className='smallFont'>
                                                Mark to display on website via integrated link.
                                            </span>
                                        </div>
                                        {
                                            !editMode &&
                                                <div className="form-check">
                                                    <input
                                                        className="form-check-input"
                                                        type="checkbox"
                                                        id="flexCheckDefault"
                                                        checked={notifyOnMobile}
                                                        onChange={(e) => setNotifyOnMobile(e.target.checked)}
                                                    />
                                                    <span className='smallFont'>
                                                        Mark to notify on mobile app.
                                                    </span>
                                                </div>
                                        }
                                    </div>
                                </div>
                        }
                        { (!editMode && postNoticeActiveTab === 1) &&
                            <div className="col-12 p-0 postNoticeTab form-group">
                                <div className='row '>
                                    <div className='col-12 p-1'>
                                        <div className='assigneeTabMessage'>You can only add the assignees for the Category and Departments that has given from Grant access.</div>
                                    </div>

                                    <div className="col-12">
                                        <select
                                            className="form-control postNoticeInput"
                                            style={ { outline: "none", padding: 2 }}
                                            onChange={ (e) => selectNoticeAcademicYear(e)}
                                            value={ noticeAcademicYearId }
                                        >
                                            {
                                                academicYearList &&
                                                    Object.keys(academicYearList).map((yearId) => {
                                                        return (
                                                            <option key={yearId} value={yearId}>{academicYearList[yearId].year_text}</option>
                                                        );
                                                    })
                                                }
                                        </select>
                                    </div>
                                    <div className='col-12'>
                                        <div className='assigneeTabDiv'>
                                            {
                                                assigneeTabArray.map(tab => {
                                                    return(
                                                        <div onClick={() => selectAssigneeTab(tab)} className={ tab.tabName === assigneeTab ? 'activeAssigneeTab' : 'assigneeTab' }>
                                                            {tab.tabName}
                                                        </div>
                                                    );
                                                })
                                            }
                                        </div>
                                        {
                                            assigneeTab == 'STUDENTS' &&
                                                <>
                                                    <div className="col-md-12 assigneeObject-selection" style={{ padding: 0 }}>
                                                        <div className="select-all-department">
                                                            <input
                                                                type="checkbox"
                                                                checked={Object.keys(assigneesDetails.student).length > 0 && (Object.keys(assigneesDetails.student).length == Object.keys(studentAssigneeObject).length)}
                                                                style={{ marginRight: 10 }}
                                                                onChange={(e) => selectAllStudentDepartments(e)}
                                                            />
                                                            <span style={{ fontWeight: 'bold' }}>Select All Department</span>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-12 assigneeObject-selection" style={{ padding: 0 }}>
                                                        {
                                                            student ?
                                                            <ButtonLoader/>
                                                            :
                                                            Object.keys(studentAssigneeObject).length > 0 &&
                                                                Object.values(studentAssigneeObject).map(department => {
                                                                    return(
                                                                        <div className="studentDept">
                                                                            <input
                                                                                type='checkbox'
                                                                                checked={Object.keys(assigneesDetails.student).length > 0 && assigneesDetails.student[department.departmentId] != undefined}
                                                                                onChange={(e) => selectSingleStudentDepartment(e, department.departmentId)}
                                                                                style={{ marginRight: 5, marginTop: 10 }}
                                                                            />
                                                                            <div className="studentDept-container">
                                                                                <div className="student-department" onClick={() => collapseStudentDepartment(department.departmentId)} >
                                                                                    <div className="department-selection">
                                                                                        <span style={{ fontWeight: 'bold' }}>{department.departmentName}</span>
                                                                                    </div>
                                                                                    <FontAwesomeIcon icon={['fas', department.collapsible ? 'angle-up' : 'angle-down']} style={{ cursor: 'pointer' }} size="lg" />
                                                                                </div>
                                                                                {
                                                                                    department.collapsible &&
                                                                                        <div className="collapsedContainer">
                                                                                            <div className="groupContainer">
                                                                                                {
                                                                                                    Object.keys(department.groupDetails).length > 0 ?
                                                                                                        Object.values(department.groupDetails).map(group => {
                                                                                                            return(
                                                                                                                <div className="group-details">
                                                                                                                    <input
                                                                                                                        type="checkbox"
                                                                                                                        checked={assigneesDetails.student[department.departmentId] != undefined && assigneesDetails.student[department.departmentId][group.groupId] != undefined}
                                                                                                                        onChange={(e) => selectSingleGroup(e, department.departmentId, group.groupId)}
                                                                                                                        style={{ marginRight: 5 }}
                                                                                                                    />
                                                                                                                    <span>{group.groupName}</span>
                                                                                                                </div>
                                                                                                            );
                                                                                                        })
                                                                                                    :
                                                                                                        <p>No groups assigned to {department.departmentName}.</p>
                                                                                                }
                                                                                            </div>
                                                                                        </div>
                                                                                }
                                                                            </div>
                                                                        </div>
                                                                    );
                                                                })
                                                        }
                                                    </div>
                                                </>
                                        }
                                        {
                                            assigneeTab == 'TEACHING' &&
                                                <>
                                                    <div className="col-md-12 assigneeObject-selection" style={{ padding: 0 }}>
                                                        <div className="select-all-department">
                                                            <input
                                                                type="checkbox"
                                                                checked={Object.keys(assigneesDetails.teaching).length > 0 && (Object.keys(assigneesDetails.teaching).length == Object.keys(teachingAssigneeObject).length)}
                                                                style={{ marginRight: 10 }}
                                                                onChange={(e) => selectAllTeachingDepartments(e)}
                                                            />
                                                            <span style={{ fontWeight: 'bold' }}>Select All Department</span>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-12 assigneeObject-selection" style={{ padding: 0 }}>
                                                        {
                                                            teaching ?
                                                            <ButtonLoader/>
                                                            :
                                                            Object.keys(teachingAssigneeObject).length > 0 &&
                                                                Object.values(teachingAssigneeObject).map(department => {
                                                                    return(
                                                                        <div className="studentDept">
                                                                            <input
                                                                                type='checkbox'
                                                                                checked={Object.keys(assigneesDetails.teaching).length > 0 && assigneesDetails.teaching[department.departmentId] != undefined}
                                                                                onChange={(e) => selectSingleTeachingDepartment(e, department.departmentId)}
                                                                                style={{ marginRight: 5, marginTop: 10 }}
                                                                            />
                                                                            <div className="studentDept-container">
                                                                                <div className="student-department" onClick={() => collapseTeachingDepartment(department.departmentId)}>
                                                                                    <div className="department-selection d-flex">
                                                                                        <span style={{ fontWeight: 'bold' }}>{department.departmentName}</span>
                                                                                        <input
                                                                                            id='defaultBranchCheckbox'
                                                                                            className="ml-2"
                                                                                            type="checkbox"
                                                                                            checked={isDefaultBranchOn}
                                                                                            onChange={() => setIsDefaultBranchOn(prev => !prev)}
                                                                                        />
                                                                                        <label 
                                                                                            htmlFor="defaultBranchCheckbox"
                                                                                            className="ml-1"
                                                                                            style={{ fontSize: '11px', cursor: 'pointer' }} 
                                                                                        >
                                                                                            Click to show employees with default branch only
                                                                                        </label>
                                                                                    </div>
                                                                                    <FontAwesomeIcon icon={['fas', department.collapsible ? 'angle-up' : 'angle-down']} style={{ cursor: 'pointer' }} size="lg" />
                                                                                </div>
                                                                                {
                                                                                    department.collapsible &&
                                                                                    <div className="collapsedContainer">
                                                                                        <div className="facultyList-container">
                                                                                            {
                                                                                                department.facultyList.length > 0 ?
                                                                                                department.facultyList.map((faculty, facultyIndex) => {
                                                                                                    if(!isDefaultBranchOn || department.departmentId == faculty.defaultStreamId) {
                                                                                                        return(
                                                                                                            <div className="faculty-data">
                                                                                                                <input
                                                                                                                    type="checkbox"
                                                                                                                    checked={selectedTeachingFaculty[department.departmentId] != undefined && selectedTeachingFaculty[department.departmentId].includes(faculty.faculty_id)}
                                                                                                                    onChange={() => selectTeachingFaculty(department.departmentId, faculty.faculty_id)}
                                                                                                                    style={{ marginRight: 5 }}
                                                                                                                />
                                                                                                                <span>{faculty.faculty_fname + ' ' + faculty.faculty_lname}</span>
                                                                                                            </div>
                                                                                                        );
                                                                                                    }
                                                                                                }) :
                                                                                                <p>No faculty is assigned to {department.departmentName}.</p>
                                                                                            }
                                                                                        </div>
                                                                                    </div>
                                                                                }
                                                                            </div>
                                                                        </div>
                                                                    );
                                                                })
                                                        }
                                                    </div>
                                                </>
                                        }
                                        {
                                            assigneeTab == 'NON-TEACHING' &&
                                                <>
                                                    <div className="col-md-12 assigneeObject-selection" style={{ padding: 0 }}>
                                                        <div className="select-all-department">
                                                            <input
                                                                type="checkbox"
                                                                checked={Object.keys(assigneesDetails.non_teaching).length > 0 && (Object.keys(assigneesDetails.non_teaching).length == Object.keys(nonTeachingAssigneeObject).length)}
                                                                style={{ marginRight: 10 }}
                                                                onChange={(e) => selectAllNonTeachingDepartments(e)}
                                                            />
                                                            <span style={{ fontWeight: 'bold' }}>Select All Department</span>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-12 assigneeObject-selection" style={{ padding: 0 }}>
                                                        {
                                                             nonTeaching ?
                                                             <ButtonLoader/>
                                                             :
                                                            Object.keys(nonTeachingAssigneeObject).length > 0 &&
                                                                Object.values(nonTeachingAssigneeObject).map(department => {
                                                                    return(
                                                                        <div className="studentDept">
                                                                            <input
                                                                                type='checkbox'
                                                                                checked={Object.keys(assigneesDetails.non_teaching).length > 0 && assigneesDetails.non_teaching[department.departmentId] != undefined}
                                                                                onChange={(e) => selectSingleNonTeachingDepartment(e, department.departmentId)}
                                                                                style={{ marginRight: 5, marginTop: 10 }}
                                                                            />
                                                                            <div className="studentDept-container">
                                                                                <div className="student-department" onClick={() => collapseNonTeachingDepartment(department.departmentId)}>
                                                                                    <div className="department-selection">
                                                                                        <span style={{ fontWeight: 'bold' }}>{department.departmentName}</span>
                                                                                        <input
                                                                                            id='defaultBranchCheckbo'
                                                                                            className="ml-2"
                                                                                            type="checkbox"
                                                                                            checked={isDefaultBranchOn}
                                                                                            onChange={() => setIsDefaultBranchOn(prev => !prev)}
                                                                                        />
                                                                                        <label 
                                                                                            htmlFor="defaultBranchCheckbo"
                                                                                            className="ml-1"
                                                                                            style={{ fontSize: '11px', cursor: 'pointer' }} 
                                                                                        >
                                                                                            Click to show employees with default branch only
                                                                                        </label>
                                                                                    </div>
                                                                                    <FontAwesomeIcon icon={['fas', department.collapsible ? 'angle-up' : 'angle-down']} style={{ cursor: 'pointer' }} size="lg" />
                                                                                </div>
                                                                                {
                                                                                    department.collapsible &&
                                                                                    <div className="collapsedContainer">
                                                                                        <div className="facultyList-container">
                                                                                            {
                                                                                                fetchingFaculty ?
                                                                                                <ButtonLoader /> :
                                                                                                department.facultyList.length > 0 ?
                                                                                                department.facultyList.map((faculty, facultyIndex) => {
                                                                                                    if(!isDefaultBranchOn || department.departmentId == faculty.defaultStreamId) {
                                                                                                        return(
                                                                                                            <div className="faculty-data">
                                                                                                                <input
                                                                                                                    type="checkbox"
                                                                                                                    checked={selectedNonTeachingFaculty[department.departmentId] != undefined && selectedNonTeachingFaculty[department.departmentId].includes(faculty.faculty_id)}
                                                                                                                    onChange={() => selectNonTeachingFaculty(department.departmentId, faculty.faculty_id)}
                                                                                                                    style={{ marginRight: 5 }}
                                                                                                                />
                                                                                                                <span>{faculty.faculty_fname + ' ' + faculty.faculty_lname}</span>
                                                                                                            </div>
                                                                                                        );
                                                                                                    }
                                                                                                }) :
                                                                                                <p>No faculty is assigned to {department.departmentName}.</p>
                                                                                            }
                                                                                        </div>
                                                                                    </div>
                                                                                }
                                                                            </div>
                                                                        </div>
                                                                    );
                                                                })
                                                        }
                                                    </div>
                                                </>
                                        }
                                    </div>
                                </div>

                            </div>
                        }

                        {/* { (!editMode && postNoticeActiveTab === 2) && <div className="col-12 p-0 postNoticeTab form-group">
                            <div className='p-3 col-12'>
                                <div className='row border'>
                                    <div className='col-2 '>Image</div>
                                    <div className='col-10 '>
                                        <div className='d-flex'>
                                            <div className='flex-grow-1 previewCardTitle'>{ postNoticeData.title }</div>
                                            <div className=''>attachment</div>
                                        </div>
                                        <div className='previewCardDecs'>{ postNoticeData.description }</div>
                                        <div className='previewCardCategoryDepartment'>
                                            <div className='previewCardCategory'>{ categoryList[postNoticeData.category_id]?.categoryName }</div>
                                            {
                                                Object.values(addedDepartment).map(stream => {
                                                    return <div className='previewCardDepartment'>{ stream.stream_name }</div>
                                                })
                                            }

                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className='col-12 previewAssignee'>
                                <div className='cardAssigneeTitle'>Assignees</div>
                                <div className='cardFaculty'><span className='cardFacultyTitle'>STUDENTS</span> <span className='cardFacultyValue'>25 Students Selected</span> </div>
                                <div className='cardFaculty'><span className='cardFacultyTitle'>TEACHERS</span> <span className='cardFacultyValue'>20 Teachers Selected</span> </div>
                                <div className='cardFaculty'><span className='cardFacultyTitle'>NON - TEACHERS</span> <span className='cardFacultyValue'>12 Non-Teachers Selected</span> </div>
                            </div>
                        </div> } */}

                        <div className="col-md-12 d-flex justify-flex-end align-items-center buttonContainer">
                            <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
                                {
                                    (!editMode && postNoticeActiveTab === 1) &&
                                    <>
                                        {
                                            assignAssignee &&
                                            <ButtonLoader />
                                        }
                                        <button type="button" className="py-1 btn btn-outline-primary" disabled={assignAssignee} onClick={() => setPostNoticeActiveTab(postNoticeActiveTab - 1)}>
                                            Previous
                                        </button>
                                    </>
                                }
                                {
                                    (!editMode && postNoticeActiveTab === 0) &&
                                    <>
                                        {
                                            postingNotice &&
                                            <ButtonLoader />
                                        }
                                        <button type="button" className="btn py-1" style={{ backgroundColor: "#0465AC", color: "white" }} disabled={postingNotice} onClick={() => validateBasicDetails()}>
                                            Save & Continue
                                        </button>
                                    </>
                                }
                                {
                                    (!editMode && postNoticeActiveTab === 1) && 
                                        <>
                                            <button 
                                                type="button" 
                                                className="btn py-1" 
                                                style={{ backgroundColor: "#0465AC", color: "white" }} disabled={assignAssignee} 
                                                onClick={() => validationToAssignAssignee()}>
                                                Save
                                            </button>
                                        </>
                                }
                                {
                                    editMode && 
                                        <>
                                            {
                                                postingNotice &&
                                                    <ButtonLoader />
                                            }
                                            <button type="button" className="btn py-1" style={{ backgroundColor: "#0465AC", color: "white" }} disabled={postingNotice} onClick={() => validateBasicDetails()}>
                                                Update Notice
                                            </button>
                                        </>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {
                selectCategory && categoryList && Object.keys(categoryList)?.length > 0 &&
                    returnSelectCategory()
            }
            {
                selectNoticeDepartment &&
                    returnSelectNoticeDepartment()
            }
            {
                selectNoticeInstDepartment &&
                    returnSelectNoticeInstDepartment()
            }
            {
                addCategory && categoryList && Object.keys(categoryList)?.length == 0 &&  returnAddCategory()
            }
            {
                requestAccess &&
                    returnRequestAccess()
            }
            {
                // showModalSelectCustom &&
                //     showModalSelectCustomDiv()
            }
            {
                successModalDetails.successModal &&
                    <SuccessModal
                        successModal={ successModalDetails.successModal }
                        successModalType={ successModalDetails.successModalType }
                        successMessage={ successModalDetails.successMessage }
                        closeSuccessModal={ closeSuccessModal }
                    />
            }
        </>
    );
}

export default PostNotice;